export default {
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    view: 'Anzeigen',
    create: 'Erstellen',
    back: 'Zurück',
    clear: 'Leeren',
    remove: 'Entfernen',
    language: 'Sprache',
    pagination: { page: 'Seite', of: 'von', item: 'Element', items: 'Elemente', total: 'Insgesamt' },
    optional: 'optional',
    close: 'Schließen',
    expand: 'Ausklappen',
    collapse: 'Einklappen',
    confirm: 'Bestätigen',
    decline: 'Ablehnen',
    accept: 'Annehmen',
    loading: 'Wird geladen…',
    noResults: 'Keine Ergebnisse gefunden',
    noResultsHint: 'Versuchen Sie, Ihre Filter oder Suchbegriffe anzupassen',
    actions: 'Aktionen',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    yes: 'Ja',
    no: 'Nein',
    search: 'Suchen…',
    filter: 'Filtern',
    all: 'Alle',
    total: 'Gesamt',
    notes: 'Notizen',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    price: 'Preis',
    duration: 'Dauer',
    category: 'Kategorie',
    description: 'Beschreibung',
    dashboard: 'Dashboard',
    settings: 'Einstellungen',
    profileLabel: 'Profil',
    today: 'Heute',
    tomorrow: 'Morgen',
    upcoming: 'Bevorstehend',
    past: 'Vergangen',
    calMode: { day: 'Tag', week: 'Woche', month: 'Monat' },
    logout: 'Abmelden',
    trialBanner: {
        daysLeft: 'Kostenlose Testphase — {{days}} Tage verbleibend',
        endsToday: 'Testphase endet heute',
        endsOn: 'endet am {{date}}',
        upgrade: 'Jetzt upgraden, um Ihren Shop weiter zu betreiben',
    },
    // Shown to a shop's staff once its trial or plan has ended (PlanEnded.tsx)
    planEnded: {
        titleTrial: "Ihre kostenlose Testphase ist beendet",
        titlePlan: "Ihr GetFade-Plan ist abgelaufen",
        titleSuspended: "Dieser Salon wurde pausiert",
        dataSafe: "Ihre Termine, Kunden und Friseure bleiben gespeichert. Es wurde nichts gelöscht.",
        off: "Das Dashboard, die iPhone-App und Ihre Online-Buchungsseite sind vorerst ausgeschaltet.",
        renew: "GetFade kostet €10 im Monat. Schreiben Sie uns, und wir schalten Ihren Salon wieder frei.",
        renewSuspended: "Schreiben Sie uns, und wir helfen Ihnen, Ihren Salon zurückzubekommen.",
        emailCta: "Schreiben Sie uns, um weiterzumachen",
        emailSubject: "GetFade fortsetzen: {{shop}}",
        askOwner: "Bitten Sie den Salon-Inhaber, den Plan zu verlängern, um wieder Zugang zu erhalten.",
        signOut: "Abmelden",
        endedOn: "Beendet am {{date}}",
    },


    // Legal pages (Privacy / Terms / Security)
    legal: {
        updated: 'Zuletzt aktualisiert',
        rights: 'Alle Rechte vorbehalten.',
        contact: {
            title: 'Kontakt',
            body: 'Fragen zu dieser Richtlinie? Schreiben Sie an getfade.io@gmail.com — wir antworten innerhalb weniger Werktage.',
        },
        privacy: {
            title: "Datenschutzerklärung",
            updated: "2. November 2026",
            intro: "Diese Erklärung beschreibt, wie GetFade — die Website getfade.io und die GetFade-Apps für iPhone, iPad und Android — personenbezogene Daten verarbeitet. GetFade wird von Ramadan Durguti betrieben, einer Privatperson mit Sitz im Kosovo („wir“). Du erreichst uns unter getfade.io@gmail.com.",
            sections: [
                { title: "Verantwortlicher", body: "Für die Daten von Shop-Inhabern und Mitarbeitenden, die GetFade nutzen, sind wir verantwortlich. Für die Daten der Kunden eines Shops (Buchungen, Namen, Kontaktdaten) ist der Barbershop verantwortlich; wir verarbeiten sie in seinem Auftrag und nur, um den Dienst für ihn zu erbringen. Kunden mit Fragen zu ihren Buchungsdaten können sich an den Shop oder an uns wenden." },
                { title: "Welche Daten wir erheben", body: "Kontodaten: Name, E-Mail-Adresse, Passwort (gehasht gespeichert), Kontokennung, Sprache und ein optionales Profilbild. Shop-Daten: Name, Adresse, Logo, Öffnungszeiten, Leistungen, Preise und Teammitglieder. Buchungsdaten, die Shops oder ihre Kunden eingeben: Kundennamen, Telefonnummern, E-Mail-Adressen, Termine, Leistungen und Notizen. Fotos und Videos, die du hinzufügst. Technische Daten: IP-Adresse, Browser- und Gerätetyp, Anmeldesitzungen, Sicherheitsprotokolle und Cookies. Push-Token, wenn du Mitteilungen in einer GetFade-App erlaubst." },
                { title: "Anmeldung mit Apple und Google", body: "Wenn du „Mit Apple anmelden“ nutzt, erhalten wir deinen Namen, deine E-Mail-Adresse (eventuell eine private Relay-Adresse von Apple) und eine Apple-Kontokennung. Wenn du „Mit Google fortfahren“ auf der Website oder in den Apps nutzt, erhalten wir deinen Namen, deine E-Mail-Adresse und eine Google-Kontokennung. Wir verwenden diese Daten nur, um dein Konto zu erstellen und dich anzumelden." },
                { title: "App-Berechtigungen", body: "Die GetFade-Apps fragen nur dann nach Kamerazugriff, wenn du ein Foto aufnehmen oder einen QR-Code scannen möchtest, und nur dann nach Mikrofonzugriff, wenn du ein Video aufnehmen möchtest. Der Zugriff auf die Fotomediathek dient nur dazu, exportierte Bilder und Dateien wie QR-Codes zu sichern. Name, E-Mail-Adresse, Telefonnummer, Fotos und Videos, andere von dir hinzugefügte Inhalte und die Kontokennung werden in den Apps nur für deren Funktion verwendet. Wir betreiben kein Tracking." },
                { title: "Wofür und auf welcher Grundlage", body: "Um den Dienst zu erbringen, für den du dich angemeldet hast: Online-Buchung, Kalender, Kundenkartei, Berichte, Buchungsbestätigungen und Erinnerungen per E-Mail sowie Buchungsbenachrichtigungen in der App und als Push-Mitteilung (Vertragserfüllung). Um GetFade sicher zu halten und Missbrauch zu verhindern, z. B. Bot-Schutz in öffentlichen Buchungsformularen (berechtigtes Interesse). Zur Erfüllung gesetzlicher Pflichten. Optionale Cookies nutzen wir nur mit Einwilligung. Wir verkaufen keine personenbezogenen Daten und nutzen sie nicht für Werbung oder app-übergreifendes Tracking." },
                { title: "Dienstleister", body: "Wir geben Daten nur an Dienstleister weiter, die uns beim Betrieb von GetFade helfen, auf Grundlage von Datenschutzvereinbarungen: unser Cloud-Hosting-Anbieter (Server und Datenbank); Resend (E-Mail-Versand); Cloudflare Turnstile (Bot-Schutz in öffentlichen Buchungsformularen); Apple (optionale Anmeldung mit Apple in den Apps); Google (optionale Anmeldung mit Google auf der Website und in den Apps sowie Webfonts); Apple Push Notification service und Google Firebase Cloud Messaging (Zustellung von Push-Mitteilungen an die iPhone- und Android-Apps). Außerdem geben wir Daten heraus, wenn das Gesetz es verlangt." },
                { title: "Übermittlung in Drittländer", body: "Einige dieser Anbieter verarbeiten Daten außerhalb des Kosovo und der EU, etwa in den USA. In diesen Fällen stützen wir uns auf die rechtlichen Garantien des Anbieters, z. B. die EU-Standardvertragsklauseln oder einen Angemessenheitsbeschluss." },
                { title: "Speicherdauer", body: "Konto- und Shop-Daten speichern wir, solange das Konto besteht. Wenn du dein Konto unter Einstellungen → Sicherheit löschst, wird es sofort entfernt; löscht der letzte Administrator eines Shops sein Konto, werden auch der Shop und seine Buchungsdaten gelöscht, ebenso die Mitarbeiterkonten, die nur für diesen Shop bestehen. Kopien in Backups werden innerhalb von 30 Tagen überschrieben. Sicherheitsprotokolle und Sitzungen bewahren wir nur so lange auf, wie es zum Schutz des Dienstes nötig ist. Push-Token werden entfernt, wenn du dich in der App abmeldest oder sie deinstallierst." },
                { title: "Deine Rechte", body: "Du kannst Auskunft, Berichtigung, Datenübertragbarkeit und Löschung deiner Daten verlangen, der Verarbeitung auf Grundlage berechtigter Interessen widersprechen und Einwilligungen jederzeit widerrufen. Vieles davon kannst du selbst in den Kontoeinstellungen erledigen; ansonsten schreib an getfade.io@gmail.com, wir antworten innerhalb von 30 Tagen. Außerdem kannst du dich bei der kosovarischen Agentur für Information und Datenschutz (AIP) oder bei der Datenschutzbehörde deines Landes beschweren." },
                { title: "Kinder", body: "GetFade richtet sich nicht an Kinder. Shop-Konten sind für Personen ab 18 Jahren. Kunden unter 16 Jahren sollten mit Hilfe eines Elternteils oder Erziehungsberechtigten buchen." },
                { title: "Sicherheit", body: "Daten werden bei der Übertragung verschlüsselt, sensible Felder auch bei der Speicherung, und der Zugriff ist beschränkt. Details findest du auf unserer Sicherheitsseite." },
                { title: "Cookies", body: "Wir verwenden notwendige Cookies, um dich angemeldet zu halten und Einstellungen zu speichern. Optionale Cookies setzen wir erst, nachdem du im Cookie-Banner zugestimmt hast. Details stehen in unserer Cookie-Richtlinie." },
                { title: "Änderungen", body: "Wir passen diese Erklärung an, wenn sich GetFade ändert. Bei wesentlichen Änderungen informieren wir dich vorab per E-Mail oder in der App." },
            ],
        },
        support: {
            title: "GetFade-Support",
            updated: "2. November 2026",
            intro: "Brauchst du Hilfe mit deinem Konto, Terminen oder Shop-Einstellungen? Schreib an <mail>getfade.io@gmail.com</mail>. Gib deinen Shop-Namen an und beschreibe das Problem. Sende niemals dein Passwort.",
            signInTitle: "Anmeldung auf iPhone und iPad",
            signInBody: "Die App für iPhone und iPad unterstützt E-Mail und Passwort, „Mit Apple anmelden“ und „Mit Google fortfahren“. Passwort vergessen, oder möchtest du eines zu einem mit Apple oder Google erstellten Konto hinzufügen? Wähle <forgot>Passwort vergessen</forgot> und nutze dieselbe E-Mail-Adresse.",
            deleteTitle: "Konto löschen",
            deleteBody: "Öffne Einstellungen, dann Sicherheit, dann Konto löschen. Hat dein Konto ein Passwort, gib es zuerst ein. Danach senden wir dir einen 6-stelligen Code per E-Mail; gib ihn ein, um den Vorgang abzuschließen. Konten ohne Passwort (mit Apple oder Google erstellt) brauchen nur den Code. Dein Konto wird sofort entfernt. Löscht der letzte Administrator eines Shops sein Konto, werden auch der Shop und seine Buchungsdaten gelöscht, ebenso die Mitarbeiterkonten, die nur für diesen Shop bestehen. Das kann nicht rückgängig gemacht werden.",
            privacyTitle: "Datenschutz",
            privacyBody: "Lies unsere <privacy>Datenschutzerklärung</privacy> und unsere <terms>Nutzungsbedingungen</terms>.",
        },
        terms: {
            title: "Nutzungsbedingungen",
            updated: "Oktober 2026",
            intro: "Diese Bedingungen gelten für die Nutzung von GetFade — der Website getfade.io und der GetFade-Apps — angeboten von Ramadan Durguti, einer Privatperson mit Sitz im Kosovo („wir“). Mit der Erstellung eines Kontos oder der Nutzung von GetFade stimmst du ihnen zu. Kontakt: getfade.io@gmail.com.",
            sections: [
                { title: "Dein Konto", body: "Für ein Shop-Konto musst du mindestens 18 Jahre alt sein. Halte deine Zugangsdaten sicher; du bist für Aktivitäten in deinem Konto und für die von dir eingeladenen Teammitglieder verantwortlich." },
                { title: "Nutzung des Dienstes", body: "Nutze GetFade, um deinen Barbershop sowie dessen Buchungen und Kunden zu verwalten. Nutze es nicht für Rechtswidriges, für Spam oder um den Dienst oder andere Nutzer zu stören." },
                { title: "Kostenloser Test und Preis", body: "Neue Shops erhalten 3 Monate kostenlos mit allen Funktionen, ohne Zahlungskarte. Danach kostet GetFade €10 pro Monat und Shop. Vor Ende des Testzeitraums kontaktieren wir dich, um die Zahlung direkt mit uns zu vereinbaren; In-App-Käufe gibt es nicht. Wenn du nicht weitermachst, können wir deinen Shop pausieren, bis ein Plan aktiv ist. Preise in Euro; anfallende Steuern werden auf der Rechnung ausgewiesen." },
                { title: "Kündigung", body: "Du kannst deinen Plan jederzeit beenden; er endet mit Ablauf des bereits bezahlten Monats, anteilige Erstattungen gibt es nur, wenn das Gesetz sie vorschreibt. Nutzt du GetFade als Verbraucher und nicht als Unternehmen, bleiben dir die Rechte aus zwingendem Verbraucherrecht erhalten." },
                { title: "Deine Daten und die deiner Kunden", body: "Die Geschäfts-, Kunden- und Buchungsdaten, die du in GetFade eingibst, gehören dir. Du bist dafür verantwortlich, eine Rechtsgrundlage für die Weitergabe der Daten deiner Kunden an uns zu haben. Wir verarbeiten sie nur in deinem Auftrag und wie in der Datenschutzerklärung beschrieben." },
                { title: "Verfügbarkeit", body: "Wir arbeiten daran, GetFade rund um die Uhr verfügbar zu halten, können einen unterbrechungsfreien Betrieb aber nicht garantieren. Geplante Wartungen kündigen wir nach Möglichkeit an." },
                { title: "Konto beenden", body: "Du kannst dein Konto jederzeit unter Einstellungen → Sicherheit löschen. Bist du der letzte Administrator eines Shops, werden damit auch der Shop und seine Daten gelöscht. Konten, die gegen diese Bedingungen verstoßen, können wir sperren oder schließen, nach Möglichkeit mit Vorankündigung." },
                { title: "Haftung", body: "GetFade wird „wie besehen“ bereitgestellt. Soweit gesetzlich zulässig, haften wir nicht für indirekte Schäden oder Folgeschäden, und unsere Gesamthaftung ist auf die Gebühren begrenzt, die du uns in den 12 Monaten vor dem Anspruch gezahlt hast. Nichts in diesen Bedingungen beschränkt eine Haftung, die gesetzlich nicht beschränkt werden kann." },
                { title: "Anwendbares Recht", body: "Es gilt das Recht der Republik Kosovo; zuständig sind die Gerichte des Kosovo. Als Verbraucher behältst du zusätzlich den Schutz der zwingenden Gesetze deines Wohnsitzlandes." },
                { title: "Änderungen", body: "Wir können diese Bedingungen anpassen, wenn sich GetFade weiterentwickelt. Wesentliche Änderungen kündigen wir mindestens 14 Tage vorher per E-Mail oder in der App an." },
            ],
        },
        security: {
            title: 'Sicherheit',
            updated: 'April 2026',
            intro: 'Der Schutz der Daten Ihres Shops ist uns wichtig. So schützt GetFade Kundendaten und Buchungen.',
            sections: [
                { title: 'Verschlüsselung', body: 'Der gesamte Datenverkehr zwischen Ihren Geräten und GetFade wird mit TLS 1.2+ verschlüsselt. Sensible Daten werden im Ruhezustand mit AES-256 verschlüsselt.' },
                { title: 'Infrastruktur', body: 'GetFade läuft auf verwaltetem Cloud-Hosting mit verschlüsselten Verbindungen zur Datenbank. Der Zugriff auf Produktivsysteme ist auf die Betreiber beschränkt, die ihn benötigen.' },
                { title: 'Zugriffskontrolle', body: 'Nur die von Ihnen eingeladenen Teammitglieder haben Zugriff auf Ihre Shop-Daten. Der interne Zugriff durch GetFade-Mitarbeiter ist streng eingeschränkt, protokolliert und ausschließlich für Support- oder Betriebszwecke zulässig.' },
                { title: 'Datenschutz', body: 'Sensible Felder — Telefonnummern und Notizen von Kunden sowie Authentifizierungs-Geheimnisse — werden nicht nur bei der Übertragung, sondern auch in der Datenbank verschlüsselt gespeichert. GetFade wickelt keine Kartenzahlungen ab und verarbeitet niemals Kartennummern.' },
                { title: 'Authentifizierung', body: 'Passwörter werden mit branchenüblichen Algorithmen gehasht. Zwei-Faktor-Authentifizierung steht zur Verfügung und wird allen Shop-Inhabern empfohlen.' },
                { title: 'Schwachstellenmeldung', body: 'Sicherheitslücke gefunden? Bitte an getfade.io@gmail.com melden. Wir begrüßen Meldungen in gutem Glauben und reagieren zeitnah.' },
            ],
        },
    },

    // Days of week
    days: {
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
    },

    daysShort: {
        monday: 'Mo',
        tuesday: 'Di',
        wednesday: 'Mi',
        thursday: 'Do',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'So',
    },

    // Days of week (lowercase for "returns to" context)
    daysAccusative: {
        monday: 'montag',
        tuesday: 'dienstag',
        wednesday: 'mittwoch',
        thursday: 'donnerstag',
        friday: 'freitag',
        saturday: 'samstag',
        sunday: 'sonntag',
    },

    // Months
    months: {
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember',
    },

    nav: {
        dashboard: 'Dashboard',
        appointments: 'Termine',
        customers: 'Kunden',
        barbers: 'Friseure',
        services: 'Leistungen',
        haircuts: 'Haarschnitte',
        products: 'Produkte',
        reports: 'Berichte',
        waitlist: 'Warteliste',
        auditLogs: 'Prüfprotokoll',
        workspace: 'Arbeitsbereich',
        account: 'Konto',
        myProfile: 'Mein Profil',
        signOut: 'Abmelden',
        settings: 'Einstellungen',
        ads: 'Marktplatz',
        more: 'Mehr',
        bookingLink: 'Buchungsseite',
        copyBookingLink: 'Buchungslink kopieren',
        groupMain: 'Übersicht',
        groupManage: 'Verwaltung',
        groupInsights: 'Einblicke',
        groupSettings: 'Einstellungen',
        dashboardDesc: 'Statistiken & Termine',
        appointmentsDesc: 'Alle Buchungen & Walk-ins',
        history: 'Verlauf',
        historyDesc: 'Frühere & abgeschlossene Termine',
        customersDesc: 'Ihre Kundenliste',
        barbersDesc: 'Team & Zeitpläne',
        timeoffDesc: 'Abwesenheiten verwalten',
        servicesDesc: 'Schnitte, Trimmen & mehr',
        haircutsDesc: 'Haarschnittstile anpassen',
        productsDesc: 'Produkte & Inventar',
        reportsDesc: 'Umsatz & Analysen',
        settingsDesc: 'Shop-Info & Einstellungen',
        myProfileDesc: 'Kontodaten bearbeiten',
        signOutDesc: 'Sitzung beenden',
        signOutConfirm: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    },

    dash: {
        todayAppointments: 'Heutige Termine',
        totalCustomers: 'Kunden gesamt',
        activeBarbers: 'Aktive Friseure',
        activeServices: 'Aktive Leistungen',
        revenueToday: 'Heutiger Umsatz',
        pendingConfirmation: 'Ausstehende Bestätigung',
        completionRate: 'Abschlussrate',
        noShowRate: 'Abwesenheitsrate',
        repeatCustomers: 'Wiederkehrende Kunden',
        todayThroughput: 'Termine für heute',
        bookingsByHour: 'Buchungen pro Stunde — Umsatz aus abgeschlossenen',
        bookings: 'Buchungen',
        revenue: 'Umsatz',
        shopView: 'Salon',
        mySchedule: 'Mein Zeitplan',
        upcomingAppointments: 'Bevorstehende Termine',
        recentActivity: 'Letzte Aktivitäten',
        noUpcoming: 'Keine bevorstehenden Termine.',
        noRecent: 'Keine letzten Termine.',
        lowStock: 'Niedriger Lagerbestand',
        viewProducts: 'Produkte ansehen',
        dismiss: 'Schließen',
        monthlyGoals: 'Monatliche Ziele',
        setGoals: 'Ziele festlegen',
        editGoals: 'Bearbeiten',
        noGoals: 'Keine Ziele für diesen Monat festgelegt.',
        setGoalsLink: 'Ziele festlegen',
        revenueGoal: 'Umsatz',
        bookingsGoal: 'Buchungen',
        bookingsTrend: 'Buchungstrend',
        last14: 'Letzte 14 Tage',
        todaySchedule: 'Heutiger Zeitplan',
        barberPerf: 'Friseur-Performance',
        thisMonth: 'Diesen Monat',
        upcoming: 'Bevorstehend',
        nextScheduled: 'Nächste geplante Termine',
        viewAll: 'Alle anzeigen',
        noToday: 'Heute keine Termine',
        noBookingsToday: 'Heute keine Buchungen',
        chartHint: 'Das Diagramm aktiviert sich, sobald Termine eingehen',
        noTodayHint: 'Termine erscheinen hier, sobald sie gebucht werden.',
        noMatches: 'Keine Treffer für deine Filter',
        clearOrPress: 'Suche zurücksetzen oder Filter wechseln. Drücke',
        toCreateOne: 'um einen zu erstellen.',
        gettingStarted: 'Erste Schritte',
        newAppointment: 'Neuer Termin',
        noShowAbove: 'Über dem gesunden Bereich',
        noShowWithin: 'Im gesunden Bereich',
        noUpcomingFull: 'Keine bevorstehenden Termine',
        completed: 'abgeschlossen',
        noShow: 'nicht erschienen',
        noShows: 'nicht erschienen',
        vsLastMonth: 'vs. letzten Monat',
        thisWeek: 'diese Woche',
        topBarber: 'Top Friseur dieser Woche',
        topService: 'Top-Leistung:',
        setMonthlyGoals: 'Monatliche Ziele festlegen',
        revenueTarget: 'Umsatzziel (€)',
        bookingsTarget: 'Buchungsziel',
        saveGoals: 'Ziele speichern',
        lowStockAlert: 'Niedriger Lagerbestand',
        appointmentSingular: 'Termin',
        appointments: 'Termin',
        appointmentsPlural: 'Termine',
        walkin: 'Walk-in',
        customize: 'Dashboard-Anpassung',
        kpiCards: 'KPI-Karten (heutige Statistiken)',
        weeklyInsights: 'Wöchentliche Einblicke',
        todaysSchedule: 'Heutiger Zeitplan',
        upcomingAppointmentsList: 'Bevorstehende Termine',
        goodDay: 'Guten Tag',
        live: 'Live',
        unassigned: 'Nicht zugewiesen',
        allClear: 'Alles klar',
        filter: 'Filter…',
        group: 'Gruppe',
        groupBy: 'Gruppiert nach',
        regulars: 'Stammkunden',
        returningCustomers: 'Wiederkehrende Kunden',
        allAppointments: 'Alle',
        pendingAppointments: 'Ausstehend',
        activeAppointments: 'Aktiv',
        completedAppointments: 'Abgeschlossen',
        confirmCount: '{{count}} bestätigen',
        firstAt: 'Erste um {{time}}',
        noBookingsYet: 'Noch keine Buchungen',
        completedCount: 'abgeschlossen',
        bookingsCount: 'Buchungen',
    },
    common: {
        needsAction: 'Aktion erforderlich',
    },
    appointmentStatus: {
        pending: 'Ausstehend',
        confirmed: 'Bestätigt',
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
        noShow: 'Nicht erschienen',
        noShowThisWeek: 'Nicht erschienen diese Woche',
        today: 'Heute',
    },

    appt: {
        title: 'Termine',
        history: 'Verlauf',
        new: 'Neuer Termin',
        newDesc: 'Geben Sie die Details ein, um einen neuen Termin zu erstellen.',
        create: 'Termin erstellen',
        edit: 'Termin bearbeiten',
        barber: 'Friseur',
        customer: 'Kunde',
        service: 'Leistung',
        startsAt: 'Startzeit',
        endsAt: 'Endzeit',
        status: 'Status',
        price: 'Preis',
        notes: 'Notizen',
        time: 'Uhrzeit',
        summary: 'Zusammenfassung',
        stillNeed: 'Noch offen',
        stepsDone: 'erledigt',
        autoFilledHint: 'Friseur und Leistung wurden vom letzten Besuch übernommen. Du kannst sie ändern.',
        clickToCreate: 'Klicken, um Termin zu erstellen',
        hidePast: 'Vergangene Termine ausblenden',
        showPast: 'Vergangene Termine anzeigen',
        searchCustomer: 'Suche oder gib einen Kundennamen ein...',
        selectTime: 'Uhrzeit wählen',
        dateFilter: 'Datumbereich',
        pending: 'Ausstehend',
        confirmed: 'Bestätigt',
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
        noShow: 'Nicht erschienen',
        show: 'Anzeigen',
        hide: 'Verbergen',
        cancelledBy: 'Storniert von',
        cancelledBy_customer: 'Vom Kunden storniert',
        cancelledBy_staff: 'Vom Salon storniert',
        openFull: 'Vollständige Details öffnen',
        bookingSource: 'Buchungsquelle',
        noAppointments: 'Keine Termine gefunden.',
        noAppointmentsHint: 'Dies sind die einzigen verfügbaren Zeiten — alle anderen sind bereits gebucht.',
        cancelAppt: 'Termin stornieren',
        markComplete: 'Als abgeschlossen markieren',
        markNoShow: 'Als nicht erschienen markieren',
        selectBarberAndServiceFirst: 'Wählen Sie zuerst einen Friseur und eine Leistung, um verfügbare Zeiten zu sehen.',
        selectServiceFirst: 'Wählen Sie einen Dienst, um die Verfügbarkeit des Friseurs zu sehen.',
        checkingAvailability: 'Verfügbarkeit wird geprüft…',
        availableTimes: 'Verfügbare Zeiten',
        slotsAvailable: 'verfügbar',
        noSlotsOnDate: 'Keine verfügbaren Zeiten an diesem Tag — Friseur ist frei oder vollständig ausgebucht.',
        tryDifferentDate: 'Versuche ein anderes Datum.',
        tryDifferentDateOrBarber: 'Versuche ein anderes Datum oder einen anderen Friseur.',
        doesntWorkThisDay: 'arbeitet an diesem Tag nicht.',
        nextWorkingDay: 'Nächster Arbeitstag',
        clearDates: 'Daten zurücksetzen',
        allCaughtUp: 'Alles erledigt!',
        closing: 'Schließt…',
        bookingDetails: 'Buchungsdetails',
        bookingDetailsDesc: 'Füllen Sie die Informationen aus, um einen neuen Termin zu planen.',
        editDesc: 'Aktualisieren Sie die Informationen, um diesen Termin zu ändern.',
        assignedBarber: 'Zugewiesener Friseur',
        customerName: 'Kundenname',
        phoneNumber: 'Telefonnummer',
        serviceType: 'Leistungsart',
        dateTime: 'Datum & Uhrzeit',
        internalNotes: 'Interne Notizen',
        notesPlaceholder: 'Allergien, Präferenzen, usw...',
        estimatedPrice: 'Geschätzter Preis:',
        repeat: 'Wiederholen',
        doesNotRepeat: 'Wiederholt sich nicht',
        weekly: 'Wöchentlich',
        biweekly: 'Alle 2 Wochen',
        monthly: 'Monatlich',
        bookAppointment: 'Termin buchen',
        updateAppointment: 'Termin aktualisieren',
        tip: 'Trinkgeld (€)',
        recurringAppt: 'Dies ist ein wiederkehrender Termin',
        thisOnly: 'Nur dieser Termin',
        thisFuture: 'Dieser und alle zukünftigen',
        selectBarber: 'Friseur auswählen',
        selectService: 'Leistung auswählen',
        selectDate: 'Datum auswählen',
        selectServices: 'Leistungen auswählen',
        barberFreeToday: 'ist heute frei',
        barberNotAvailableToday: 'ist heute nicht verfügbar',
        review: 'Überprüfung',
        customerInfo: 'Kundeninformationen',
        pendingDesc: 'Warten auf Bestätigung',
        can: 'Kann',
        starts: 'Beginnt',
        ends: 'Endet',
        apptStatus: 'Terminstatus',
        deleteAppt: 'Termin löschen',
        deleteConfirm: 'Sind Sie sicher, dass Sie diesen Termin löschen möchten? Dies kann nicht rückgängig gemacht werden.',
        deleteThisOnly: 'Nur diesen Termin löschen',
        deleteThisFuture: 'Diesen und alle zukünftigen löschen',
        myAppointments: 'Meine Termine',
        allAppointments: 'Alle Termine',
        mine: 'Meine',
        exportCsv: 'CSV exportieren',
        view: 'Anzeigen',
        walkIn: 'Laufkunde',
        staff: 'Personal',
        newPendingBooking: 'Neue Buchungsanfrage',
        riskHigh: 'Hohes Risiko',
        riskMedium: 'Verdächtig',
        riskFlag_no_phone: 'Keine Telefonnummer angegeben',
        riskFlag_new_customer: 'Neuer Kunde',
        riskFlag_has_no_show: 'Hat Termine verpasst',
        riskFlag_frequent_no_show: 'Verpasst häufig Termine',
        riskFlag_restricted_trust: 'Eingeschränktes Konto',
        riskFlag_high_ip_activity: 'Mehrere Buchungen vom selben Gerät',
        riskFlag_frequent_canceller: 'Storniert häufig Buchungen',
        riskFlag_recent_cancel: 'Hat kürzlich eine Buchung storniert',
        notFound: 'Termin nicht gefunden',
        notFoundTitle: 'Termin nicht gefunden',
        notFoundDesc: 'Dieser Termin wurde möglicherweise gelöscht oder ist nicht mehr verfügbar. Überprüfen Sie die Terminliste für aktuelle Buchungen.',
        backToList: 'Zurück zu Terminen',
        deletedBanner: 'Dieser Termin wurde gelöscht und wird im schreibgeschützten Modus angezeigt.',
    },

    svc: {
        title: 'Leistungen',
        new: 'Neue Leistung',
        create: 'Leistung erstellen',
        edit: 'Leistung bearbeiten',
        serviceName: 'Leistungsname',
        durationMin: 'Dauer (Minuten)',
        priceDollar: 'Preis (€)',
        colorLabel: 'Farbe',
        activeStatus: 'Aktiver Status',
        activeDesc: 'Die Leistung ist sofort buchbar.',
        activeEditDesc: 'Ermöglichen Sie Kunden, diese Leistung zu sehen und zu buchen.',
        serviceDesc: 'Leistungsbeschreibung',
        newDesc: 'Definieren Sie ein neues Angebot für Ihren Salon, einschließlich Dauer und Preisgestaltung.',
        editDesc: 'Aktualisieren Sie die Details und Preise für dieses Leistungsangebot.',
        updateService: 'Leistung aktualisieren',
        uncategorized: 'Ohne Kategorie',
        clearColor: 'Zurücksetzen',
        descPlaceholder: 'Beschreiben Sie, was diese Leistung beinhaltet…',
        deleteConfirm: 'Sind Sie sicher, dass Sie diese Leistung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        serviceNamePlaceholder: 'z.B. Klassischer Haarschnitt',
        categoryPlaceholder: 'z.B. Haarschnitte',
        noServices: 'Noch keine Leistungen.',
        created: 'Leistung erstellt.',
        updated: 'Leistung aktualisiert.',
        deleted: 'Leistung gelöscht.',
    },

    hair: {
        title: 'Haarschnitte',
        new: 'Neuer Haarschnitt',
        create: 'Haarschnitt erstellen',
        edit: 'Haarschnitt bearbeiten',
        editDesc: 'Haarschnitt-Details aktualisieren',
        createNew: 'Neuen Haarschnitt erstellen',
        addCustom: 'Fügen Sie einen benutzerdefinierten Haarschnittstil für Ihren Salon hinzu',
        image: 'Bild',
        uploadImage: 'Bild hochladen',
        imagePlaceholder: 'PNG, JPG bis zu 5MB',
        name: 'Name',
        namePlaceholder: 'z.B. Klassischer Fade',
        description: 'Kurzbeschreibung',
        descPlaceholder: 'z.B. Zeitlos und sauber',
        detailedDesc: 'Detaillierte Beschreibung',
        detailedDescPlaceholder: 'Vollständige Beschreibung für KI-Bildgenerierung (optional)',
        active: 'Aktiv',
        activeDesc: 'Zeigen Sie diesen Haarschnitt Kunden an',
        createBtn: 'Haarschnitt erstellen',
        updateBtn: 'Haarschnitt aktualisieren',
        creating: 'Wird erstellt...',
        noHaircuts: 'Noch keine Haarschnitte.',
        deleteConfirm: 'Sind Sie sicher, dass Sie diesen Haarschnitt löschen möchten?',
        deleted: 'Haarschnitt gelöscht.',
        created: 'Haarschnitt erstellt.',
        updated: 'Haarschnitt aktualisiert.',
    },

    barber: {
        title: 'Friseure',
        new: 'Neuer Friseur',
        create: 'Friseur erstellen',
        edit: 'Friseur bearbeiten',
        info: 'Informationen',
        specialty: 'Spezialität',
        rating: 'Bewertung',
        totalReviews: 'Bewertungen gesamt',
        noBarbers: 'Noch keine Friseure.',
        schedule: 'Zeitplan',
        workingHours: 'Arbeitszeiten',
        weeklyWorkingHours: 'Wöchentliche Arbeitszeiten',
        scheduleDescription: 'Schalten Sie Tage ein/aus und legen Sie Start- und Endzeiten fest. Termine können nur während aktiver Stunden gebucht werden.',
        dayOff: 'Frei',
        to: 'bis',
        applyToWeekdays: 'Auf Mo–Fr anwenden',
        saveSchedule: 'Zeitplan speichern',
        maxClosingHour: 'Späteste Schließungszeit',
        maxClosingHourDesc: 'Legen Sie die späteste Zeit fest, zu der Barbiere ihren Tag beenden können. Dies begrenzt die verfügbaren Schließungszeiten bei der Terminplanung.',
        googleCalendar: 'Google Kalender',
        connected: 'Verbunden',
        notConnected: 'Nicht verbunden',
        connect: 'Verbinden',
        disconnect: 'Trennen',
        googleCalendarDesc: 'Termine mit dem Google Kalender dieses Friseurs synchronisieren.',
        fullName: 'Vollständiger Name',
        emailAddress: 'E-Mail-Adresse',
        initialPassword: 'Erstkennwort',
        specialtyExpertise: 'Spezialität / Expertise',
        calendarColor: 'Kalenderfarbe',
        color: 'Farbe',
        professionalBio: 'Berufliche Biografie',
        bio: 'Biografie',
        bioPlaceholder: 'Kurze Biografie schreiben...',
        activeSchedule: 'Aktiver Zeitplan',
        activeScheduleDesc: 'Umschalten, ob dieser Friseur für Buchungen verfügbar ist.',
        createDescription: 'Fügen Sie Ihrem Team einen neuen Friseur hinzu.',
        newDesc: 'Erstellen Sie ein neues Berufsprofil und Anmeldedaten für einen Friseur.',
        editDesc: 'Ändern Sie Profildetails, Kontaktinformationen und Status des Friseurs.',
        updateBarber: 'Friseur aktualisieren',
        you: 'Sie',
        generalist: 'Allrounder',
        offToday: 'Heute frei',
        returnsTo: 'Kommt zurück',
        markAvailable: 'Heute als verfügbar markieren',
        markUnavailable: 'Heute als nicht verfügbar markieren',
        deleteConfirm: 'Sind Sie sicher, dass Sie diesen Friseur entfernen möchten? Dies beeinflusst seine Verfügbarkeit und zukünftigen Zeitplan.',
        namePlaceholder: 'z.B. Max Mustermann',
        emailPlaceholder: 'friseur@beispiel.de',
        passwordPlaceholder: '••••••••',
        specialtyPlaceholder: 'z.B. Bartpflege',
    },

    cust: {
        title: 'Kunden',
        new: 'Neuer Kunde',
        create: 'Kunde erstellen',
        edit: 'Kunde bearbeiten',
        addCustomer: 'Kunde hinzufügen',
        editCustomer: 'Kunde bearbeiten',
        deleteCustomer: 'Kunde löschen',
        deleteConfirm: 'Sind Sie sicher? Der Kunde wird gelöscht.',
        name: 'Name',
        phone: 'Telefon',
        email: 'E-Mail',
        address: 'Adresse',
        notes: 'Notizen',
        visits: 'Besuche',
        noShows: 'Nicht erschienen',
        cancellations: 'Stornierungen',
        byStaff: 'vom Personal',
        byCustomer: 'vom Kunden',
        loyalty: 'Treue',
        trust: 'Vertrauen',
        loyaltyPoints: 'Treuepunkte',
        lastVisit: 'Letzter Besuch',
        favoriteBarber: 'Lieblingsbarber',
        noCustomers: 'Noch keine Kunden.',
        noCustomersDesc: 'Kunden werden automatisch bei der Buchung hinzugefügt, oder Sie können sie manuell hinzufügen.',
        noCustomersYet: 'Noch keine Kunden',
        addNew: 'Neuen Kunden hinzufügen',
        noResults: 'Keine Kunden gefunden.',
        namePlaceholder: 'z. B. Max Mustermann',
        phonePlaceholder: '+49 30 0000000',
        quickCode: 'Code',
        trustOk: 'Vertrauenswürdig',
        trustRestricted: 'Eingeschränkt',
        trustBlocked: 'Gesperrt',
        searchPlaceholder: 'Suchen...',
        hasNoShows: 'Hat Abwesenheiten',
        noNoShows: 'Keine Abwesenheiten',
        clearFilters: 'Filter löschen',
        sortBy: 'Sortieren nach',
        sortByVisits: 'Nach Besuchen sortieren',
        mostVisits: 'Meiste Besuche',
        leastVisits: 'Wenigste Besuche',
        mostNoShows: 'Meiste Abwesenheiten',
        leastNoShows: 'Wenigste Abwesenheiten',
        defaultSort: 'Standard',
        resetPassword: 'Passwort zurücksetzen',
        resetPasswordTitle: 'Passwort zurücksetzen',
        resetPasswordDesc: 'Legen Sie ein neues Passwort für {{name}} fest. Stellen Sie sicher, dass Sie es sicher weitergeben.',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        savePassword: 'Passwort speichern',
    },

    prod: {
        title: 'Produkte',
        new: 'Neues Produkt',
        create: 'Produkt erstellen',
        edit: 'Produkt bearbeiten',
        stock: 'Lagerbestand',
        lowStock: 'Niedriger Bestand',
        noProducts: 'Noch keine Produkte.',
        stockQty: 'Lagermenge',
        lowStockThreshold: 'Mindeststockgrenze',
        lowStockAlert: 'Niedrigbestand-Alarm',
        lowStockHint: 'Warnzeichen anzeigen, wenn der Bestand auf oder unter diese Zahl fällt.',
        productName: 'Produktname',
        activeStatus: 'Aktiver Status',
        activeDesc: 'Das Produkt kann zu Terminen hinzugefügt werden.',
        newDesc: 'Fügen Sie ein Einzelhandelsprodukt zu Ihrem Inventar für den Verkauf bei Terminen hinzu.',
        editDesc: 'Aktualisieren Sie die Details und Lagerbestände für dieses Produkt.',
        updateProduct: 'Produkt aktualisieren',
        uncategorized: 'Ohne Kategorie',
        priceDollar: 'Preis (€)',
        stockQuantity: 'Lagermenge',
        deleteConfirm: 'Sind Sie sicher, dass Sie dieses Produkt löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        namePlaceholder: 'z.B. Pomade',
        categoryPlaceholder: 'z.B. Haarpflege',
        image: 'Produktbild',
        imageDesc: 'JPG, PNG oder WebP, max. 2 MB.',
        imageInvalidType: 'Nur JPG-, PNG- oder WebP-Bilder sind erlaubt.',
        imageTooLarge: 'Das Bild ist {{size}} MB groß. Maximalgröße ist 2 MB.',
        uploadImage: 'Bild hochladen',
        changeImage: 'Bild ändern',
        sku: 'Artikelnummer',
        skuPlaceholder: 'z.B. POM-001',
        skuHint: 'Eindeutige Produktkennung oder Barcode.',
        costPrice: 'Einkaufspreis',
        costPriceHint: 'Was Sie an Ihren Lieferanten zahlen (für Margenberichte).',
        margin: 'Marge',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Optionale Hinweise auf der Produktdetailseite.',
        category: 'Kategorie',
        categoryNone: 'Keine Kategorie',
        addCategory: 'Neue Kategorie hinzufügen',
        manageCategories: 'Kategorien verwalten',
        history: 'Bestandsverlauf',
        historyEmpty: 'Noch keine Bestandsbewegungen.',
        movement: {
            sale: 'Verkauf',
            refund: 'Rückerstattung',
            adjustment: 'Anpassung',
            restock: 'Nachschub',
            initial: 'Anfangsbestand',
        },
    },

    profile: {
        title: 'Kontoeinstellungen',
        general: 'Allgemein',
        security: 'Sicherheit',
        sessions: 'Sitzungen',
        dangerZone: 'Gefahrenzone',
        bookingLink: 'Ihr Buchungslink',
        bookingLinkDesc: 'Teilen Sie diesen Link mit Ihren Kunden',
        copy: 'Kopieren',
        copied: 'Kopiert!',
        deleteAccount: 'Konto löschen',
        profileInfo: 'Profilinformationen',
        profileInfoDesc: 'Aktualisieren Sie Ihren Kontonamen und Ihre E-Mail-Adresse.',
        changePhoto: 'Foto ändern',
        removePhoto: 'Foto entfernen',
        saveChanges: 'Änderungen speichern',
        saved: 'Gespeichert.',
        emailUnverified: 'Ihre E-Mail ist nicht bestätigt.',
        resendEmail: 'Bestätigungsemail erneut senden.',
        verificationSent: 'Ein neuer Bestätigungslink wurde gesendet.',
    },

    booking: {
        title: 'Buchen',
        loadMore: 'Mehr laden',
        languagePreference: 'Sprache',
        resendingCode: 'Wird erneut gesendet…',
        confirmation: {
            title: 'Buchung bestätigt',
        },
        nav: {
            book: 'Buchen',
            appointments: 'Meine Termine',
            profile: 'Profil',
        },
        chooseBarber: 'Friseur wählen',
        chooseServices: 'Leistungen wählen',
        noServices: 'Keine Dienstleistungen verfügbar',
        noServicesDesc: 'Der Shop hat noch keine Leistungen hinzugefügt.',
        pickDateTime: 'Datum & Uhrzeit wählen',
        yourDetails: 'Ihre Angaben',
        errorNameRequired: 'Bitte geben Sie Ihren vollständigen Namen ein.',
        errorPhoneRequired: 'Bitte geben Sie Ihre Telefonnummer ein.',
        bookingSummary: 'Buchungsübersicht',
        yourName: 'Ihr vollständiger Name',
        yourPhone: 'Ihre Telefonnummer',
        specialRequests: 'Besondere Wünsche?',
        confirmBooking: 'Buchung bestätigen',
        privacyNotice: 'Deine Angaben gehen an {{shop}}, um deinen Termin zu verwalten, und werden von GetFade sicher gespeichert. <privacy>Datenschutzerklärung</privacy>',
        booking: 'Wird gebucht…',
        namePlaceholder: 'Ihr vollständiger Name',
        phonePlaceholder: '+49 XXX XXXXXXXX',
        emailPlaceholder: 'your@email.com',
        barber: 'Friseur',
        date: 'Datum',
        time: 'Uhrzeit',
        loadingSlots: 'Verfügbare Zeiten werden geladen…',
        noSlots: 'Keine verfügbaren Zeiten an diesem Tag. Bitte anderen Tag wählen.',
        barberNotWorking: 'Dieser Friseur arbeitet an diesem Tag nicht. Bitte wählen Sie ein anderes Datum.',
        barberOnTimeOff: 'Dieser Friseur hat an diesem Tag frei. Bitte wählen Sie ein anderes Datum.',
        loadingAvailability: 'Verfügbarkeit wird geladen…',
        noSlotsBadge: 'Keine Zeiten',
        continue: 'Weiter',
        anyBarber: 'Beliebiger verfügbarer Friseur',
        anyBarberDesc: 'Frühester freier Slot bei allen Friseuren',
        anyBarberFastest: 'Schnellste',
        anyBarberAutoAssign: 'Der beste verfügbare Friseur wird automatisch zugewiesen, wenn Sie eine Zeit auswählen.',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        viewMyAppts: 'Meine Termine anzeigen',
        services: 'Leistungen',
        service: 'Leistung',
        min: 'Min.',
        totalPrice: 'Gesamtpreis',
        with: 'mit',
        tryingStyle: 'Diesen Stil ausprobieren',
        bookYourVisit: 'Termin buchen.',
        heroSubtitle: 'Wählen Sie, was Sie brauchen, wem Sie vertrauen und wann. Es dauert nur eine Minute.',
        selectedCount: 'ausgewählt',
        duration: 'Dauer',
        step: {
            barber: 'Friseur',
            service: 'Leistung',
            dateTime: 'Datum & Zeit',
            info: 'Ihre Daten',
        },
        confirmed: 'Buchung bestätigt!',
        confirmedDesc: 'Alles ist bereit. Wir freuen uns auf Ihren Besuch.',
        pending: 'Termin erhalten',
        pendingDesc: 'Ihr Termin muss noch bestätigt werden. Wir werden Sie bald kontaktieren.',
        appointmentDetails: 'Termindetails',
        cancelWindow: 'Stornieren? Sie haben noch',
        graceWindow: 'Doch nicht? Sie können innerhalb von stornieren',
        cancelAppt: 'Termin stornieren',
        cancelledTitle: 'Termin storniert',
        cancelledDesc: 'Ihr Termin wurde storniert. Wir hoffen, Sie bald wieder zu sehen.',
        unavailableTitle: "{{shop}} nimmt derzeit keine Online-Buchungen an",
        unavailableDesc: "Bitte kontaktieren Sie den Salon direkt, um einen Termin zu buchen.",
        yourBookings: "Ihre Buchungen",
        viewOrCancel: "Ansehen oder stornieren",
        bookAnother: 'Neuen Termin buchen',
        shopPhone: 'Telefon des Salons',
        windowExpired: 'Das Stornierungsfenster ist abgelaufen.',
        errorInvalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein (7-15 Ziffern oder +1-15 Ziffern)',
        checkStatus: 'Buchungsstatus Überprüfen',
        statusTitle: 'Buchungsstatus',
        statusPending: 'Warten auf Bestätigung',
        statusPendingDesc: 'Der Salon wird Ihren Termin in Kürze bestätigen.',
        statusBadgePending: 'Ausstehend',
        pendingHint: 'Kommen Sie in wenigen Minuten zurück, um zu sehen, ob Ihr Termin genehmigt wurde. Der Status wird automatisch aktualisiert.',
        bookAgain: 'Erneut buchen',
        products: 'Produkte',
        noProductsYet: 'Noch keine Produkte.',
        outOfStock: 'Nicht auf Lager',
        addToCalendar: 'Zum Kalender',
        directions: 'Wegbeschreibung',
        getDirections: 'Wegbeschreibung anzeigen',
        callShop: 'Anrufen',
        cancelAppointment: 'Termin stornieren',
        cancelConfirmTitle: 'Termin stornieren?',
        cancelConfirm: 'Sind Sie sicher, dass Sie diesen Termin stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        cancelKeep: 'Termin behalten',
        confirmCancel: 'Termin stornieren',
        cancelling: 'Wird storniert…',
        myProfile: 'Mein Profil',
        profileTitle: 'Mein Profil',
        profileInfo: 'Meine Daten',
        profileInfoDesc: 'Aktualisiere Name, E-Mail und Adresse.',
        fullName: 'Vollständiger Name',
        emailLabel: 'E-Mail',
        phoneLabel: 'Telefon',
        phoneLocked: 'Telefon kann nicht geändert werden',
        addressLabel: 'Adresse',
        save: 'Speichern',
        saved: 'Änderungen gespeichert.',
        passwordSection: 'Passwort',
        passwordSectionDesc: 'Halte dein Konto mit einem starken Passwort sicher.',
        deleteAccount: 'Mein Konto löschen',
        deleteAccountDesc: 'Entfernt deinen Namen, deine Kontaktdaten und deinen Login bei {{shop}} und storniert deine kommenden Termine. Vergangene Besuche bleiben ohne deine Daten in den Unterlagen des Shops.',
        deleteAccountConfirm: 'Das kann nicht rückgängig gemacht werden.',
        deleteAccountButton: 'Konto löschen',
        deleteAccountButtonConfirm: 'Ja, mein Konto löschen',
        deleteAccountSendCode: 'Code per E-Mail senden',
        deleteAccountCodeSent: 'Wir haben einen 6-stelligen Code an {{email}} geschickt. Gib ihn ein, um dein Konto zu löschen.',
        deleteAccountCodeLabel: 'Code aus der E-Mail',
        deleteAccountResend: 'Neuen Code senden',
        accountDeleted: 'Dein Konto wurde gelöscht.',
        languageTitle: 'Bevorzugte Sprache',
        languageDesc: 'Wir zeigen diesen Shop in deiner gewählten Sprache. Überschreibt die Shop-Voreinstellung.',
        languageNotSet: 'Nicht gesetzt - Standard des Shops wird verwendet',
        languageActive: 'Aktiv',
        changePassword: 'Passwort ändern',
        setPassword: 'Passwort festlegen',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        passwordUpdated: 'Passwort aktualisiert.',
        uploadPhoto: 'Foto hochladen',
        changePhoto: 'Foto ändern',
        stillNeed: 'Noch nötig:',
        statusConfirmed: 'Ihr Termin ist Bestätigt!',
        statusConfirmedDesc: 'Ihr Termin ist bestätigt. Wir freuen uns auf Ihren Besuch.',
        statusBadgeConfirmed: 'Bestätigt',
        statusInProgress: 'Ihr Termin läuft',
        statusInProgressDesc: 'Ihr Termin wird gerade bearbeitet.',
        statusBadgeInProgress: 'In Bearbeitung',
        statusCompleted: 'Termin Abgeschlossen',
        statusCompletedDesc: 'Vielen Dank für Ihren Besuch!',
        statusBadgeCompleted: 'Abgeschlossen',
        statusCancelled: 'Termin Storniert',
        statusCancelledDesc: 'Dieser Termin wurde storniert.',
        statusBadgeCancelled: 'Storniert',
        statusNoShow: 'Nicht Erschienen',
        statusNoShowDesc: 'Sie sind zu diesem Termin nicht erschienen.',
        statusBadgeNoShow: 'Nicht Erschienen',
        trackBooking: 'Sie können Ihren Buchungsstatus jederzeit überprüfen:',
        createAccount: 'Konto erstellen',
        createAccountDesc: 'Geben Sie Ihre Daten ein, um einen Termin zu buchen. Wir bestätigen Ihre E-Mail.',
        firstName: 'Vorname',
        firstNamePlaceholder: 'Max',
        lastName: 'Nachname',
        lastNamePlaceholder: 'Mustermann',
        sendingCode: 'Code wird gesendet…',
        verifyEmail: 'E-Mail bestätigen',
        verifyEmailDesc: 'Wir haben einen 4-stelligen Code an {{email}} gesendet',
        verificationCode: 'Bestätigungscode',
        verifying: 'Wird überprüft…',
        verifyAndBook: 'Bestätigen & zur Buchung',
        didntReceiveCode: 'Code nicht erhalten?',
        resendCode: 'Code erneut senden',
        codeSent: 'Ein neuer Code wurde gesendet!',
        switchAccount: 'Konto wechseln',
        newAccount: 'Neues Konto',
        haveCode: 'Ich habe einen Code',
        quickLogin: 'Schnellanmeldung',
        quickLoginDesc: 'Geben Sie den 4-stelligen Code ein, den Sie vom Geschäft erhalten haben.',
        clientCode: 'Kundencode',
        loggingIn: 'Anmeldung...',
        loginAndBook: 'Anmelden & Buchen',
        myAppointments: 'Meine Termine',
        upcomingAppointments: 'Bevorstehend',
        pastAppointments: 'Vergangene',
        noUpcoming: 'Keine bevorstehenden Termine.',
        noPast: 'Keine vergangenen Termine.',
        bookNow: 'Jetzt buchen',
    },

    // Time Off
    timeoff: {
        title: 'Urlaub',
        deleteTitle: 'Urlaub löschen',
        manage: 'Verwalten Sie Abwesenheiten und Urlaube',
        add: 'Urlaub hinzufügen',
        noTimeOff: 'Kein Urlaub geplant.',
        upcomingActive: 'Bevorstehend & Aktiv',
        from: 'Von',
        to: 'Bis',
        reason: 'Grund (optional)',
        reasonPlaceholder: 'z.B. Urlaub, Krankheit…',
    },

    // Walk-in modal
    walkin: {
        title: 'Walk-in Schnellbuchung',
        customerName: 'Kundenname',
        namePlaceholder: 'z.B. Max Mustermann',
        service: 'Leistung',
        selectService: 'Leistung auswählen',
        barber: 'Friseur',
        selectBarber: 'Friseur auswählen',
        bookNow: 'Jetzt buchen',
        button: 'Walk-in',
        collapse: 'Einklappen',
        noBarbers: 'Zur Zeit sind keine Friseure für diesen Service verfügbar',
        noServices: 'Keine Leistungen verfügbar',
        noServicesDesc: 'Bitte fügen Sie Leistungen hinzu, bevor Sie eine Walk-in-Buchung erstellen.',
    },

    pending_requests: {
        title: '1 ausstehende Anfrage',
        description: 'Tippen Sie zur Bestätigung oder Ablehnung auf jede Anfrage',
        confirmButton: 'Bestätigen',
        declineButton: 'Ablehnen',
        cancelAppointment: 'Termin stornieren',
        cancelAppointmentTitle: 'Termin stornieren?',
        cancelAppointmentDesc: 'Der Kunde wird benachrichtigt und der Termin freigegeben. Fortfahren?',
        cancelAppointmentConfirm: 'Ja, stornieren',
        cancelAppointmentAbort: 'Nein, behalten',
        cancelledByShop: 'Vom Salon storniert',
        bannerOne: '{{count}} Buchungsanfrage wartet auf Bestätigung',
        bannerOther: '{{count}} Buchungsanfragen warten auf Bestätigung',
        review: 'Prüfen',
        modalTitleOne: '{{count}} ausstehende Anfrage',
        modalTitleOther: '{{count}} ausstehende Anfragen',
    },

    // Appointment Show page
    show: {
        overview: 'Übersicht',
        products: 'Produkte',
        customerInfo: 'Kundeninformationen',
        review: 'Bewertung',
        rating: 'Bewertung',
        comment: 'Kommentar',
        serviceDetails: 'Leistungsdetails',
        tip: 'Trinkgeld',
        payment: 'Zahlung',
        appointmentNotes: 'Terminnotizen',
        barberNotes: 'Friseurnotizen',
        noNotes: 'Keine Notizen für diesen Termin.',
        productsSold: 'Verkaufte Produkte',
        add: 'Hinzufügen',
        product: 'Produkt',
        selectProduct: 'Produkt auswählen…',
        outOfStock: '— nicht vorrätig',
        inStock: 'vorrätig',
        qty: 'Menge',
        addProduct: 'Produkt hinzufügen',
        noProducts: 'Keine Produkte zu diesem Termin hinzugefügt.',
        min: 'Min.',
        newBookingRequest: 'Neue Buchungsanfrage',
        newBookingRequestSub: 'Dieser Termin wartet auf Ihre Bestätigung.',
    },

    dm: {
        bookingLink: 'Buchungslink',
        bookingLinkDesc: 'Teilen Sie diesen Link mit Kunden.',
        copyLink: 'Link kopieren',
        copied: 'Kopiert!',
        dmTemplates: 'Schnelle DM-Vorlagen',
        template1: 'Buche deinen Termin hier 👇\n{url}',
        template2: 'Wähle deine Zeit hier 👇\n{url}',
        copy1: 'Vorlage 1 kopieren',
        copy2: 'Vorlage 2 kopieren',
    },

    auth: {
        signIn: 'Anmelden',
        signInTitle: 'Anmelden | GetFade',
        signInHeading: 'Anmelden',
        signInSub: 'Geben Sie Ihre Anmeldedaten ein, um auf Ihr Dashboard zuzugreifen.',
        signInButton: 'Anmelden',
        signingIn: 'Wird angemeldet...',
        noAccount: 'Noch kein Konto?',
        createOne: 'Jetzt erstellen',
        keepSignedIn: 'Angemeldet bleiben',
        forgot: 'Vergessen?',
        welcomeBack: 'Willkommen',
        welcomeBackAccent: 'zurück.',
        welcomeBackSub: 'Verwalten Sie Ihren Salon, Termine und Ihr Team — alles an einem Ort.',
        testimonialLogin: 'Spart mir jede Woche Stunden. Meine Kunden lieben die Online-Buchung.',
        shopOwner: '— Saloninhaber',
        statFree: '3 Monate kostenlos',
        statNoCard: 'Keine Kreditkarte',
        secureLogin: 'Sichere Anmeldung',
        register: 'Salon erstellen | GetFade',
        registerHeading: 'Ihren Salon erstellen',
        registerSub: 'Geben Sie Ihre Daten ein, um kostenlos zu starten.',
        registerButton: 'Salon erstellen',
        creatingShop: 'Ihr Salon wird erstellt...',
        alreadyAccount: 'Bereits ein Konto?',
        signInLink: 'Anmelden',
        signUp: 'Registrieren',
        shopName: 'Salonname',
        yourName: 'Ihr Name',
        phone: 'Telefon',
        password: 'Passwort',
        confirmPassword: 'Bestätigen',
        emailPlaceholder: 'du@beispiel.com',
        shopNamePlaceholder: 'Classic Cuts',
        yourNamePlaceholder: 'Max Mustermann',
        secureRegistration: 'Sichere Registrierung',
        or: 'oder',
        googleSignUp: 'Mit Google registrieren',
        googleSignIn: 'Mit Google anmelden',
        appleContinue: 'Mit Apple fortfahren',
        appleConnected: 'Mit Apple verbunden',
        googleConnected: 'Mit Google verbunden',
        terms: 'Mit der Erstellung eines Shops akzeptierst du unsere <terms>AGB</terms> und <privacy>Datenschutzerklärung</privacy>.',
        setUpShop: 'Ihren Salon',
        setUpShopAccent: 'einrichten.',
        setUpShopSub: 'Erstellen Sie Ihr Konto und nehmen Sie innerhalb von Minuten Buchungen an.',
        testimonialRegister: 'In 5 Minuten eingerichtet, bis Tagesende voll im Betrieb.',
        forgotTitle: 'Passwort vergessen | GetFade',
        forgotHeading: 'Passwort vergessen',
        forgotSub: 'Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Reset-Link.',
        forgotButton: 'Reset-Link senden',
        sendingReset: 'Wird gesendet...',
        backToLogin: 'Zurück zur Anmeldung',
        resetTitle: 'Passwort zurücksetzen | GetFade',
        resetHeading: 'Passwort zurücksetzen',
        resetSub: 'Bitte wählen Sie ein starkes, einzigartiges Passwort.',
        resetButton: 'Passwort aktualisieren',
        updatingPassword: 'Wird aktualisiert...',
        accountEmail: 'Konto-E-Mail',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen',
        remembered: 'Erinnert?',
        verifyTitle: 'E-Mail verifizieren | GetFade',
        verifyHeading: 'E-Mail verifizieren',
        verifySub: 'Vielen Dank! Um zu starten, klicken Sie bitte auf den Link, den wir an Ihr Postfach gesendet haben.',
        verifyButton: 'Bestätigungs-E-Mail erneut senden',
        sendingVerify: 'Wird gesendet...',
        verificationSent: 'Ein neuer Link wurde an Ihre E-Mail-Adresse gesendet.',
        verificationCheckEmail: 'Überprüfen Sie Ihre E-Mail',
        verificationCheckEmailSub: 'Wir haben einen Bestätigungscode an Ihre E-Mail-Adresse gesendet.',
        verificationCodeSent: 'Ein neuer Bestätigungscode wurde an Ihre E-Mail gesendet. Er läuft in 10 Minuten ab.',
        verificationCode: 'Bestätigungscode',
        verifyCode: 'Code verifizieren',
        verifyingCode: 'Wird verifiziert...',
        resendCode: 'Code erneut senden',
        verificationSuccess: 'E-Mail bestätigt!',
        verificationSuccessSub: 'Ihre E-Mail wurde erfolgreich bestätigt. Sie können jetzt auf die volle Plattform zugreifen.',
        goToDashboard: 'Zum Dashboard',
        notYourEmail: 'Nicht Ihre E-Mail?',
        wrongEmail: 'Falsche E-Mail?',
        goBack: 'Zurück',
        logOut: 'Abmelden',
        confirmTitle: 'Zugang bestätigen | GetFade',
        confirmHeading: 'Passwort erforderlich',
        confirmSub: 'Bitte bestätigen Sie Ihr Passwort, bevor Sie den gesicherten Bereich betreten.',
        confirmButton: 'Zugang bestätigen',
        verifying: 'Wird verifiziert...',
        notYou: 'Nicht Sie?',
        signInDifferent: 'Als anderer Benutzer anmelden',
    },

    // Settings - Time ago strings
    timeAgo: {
        justNow: 'Gerade eben',
        minAgo: 'vor {{count}} Min',
        hrAgo: 'vor {{count}} Std',
        daysAgo: 'vor {{count}} Tagen',
    },

    // Settings - Security & Sessions
    security: {
        twoFactorTitle: 'Zwei-Faktor-Authentifizierung',
        twoFactorDesc: 'Füge deinem Konto eine zusätzliche Sicherheitsebene hinzu.',
        enable2FA: '2FA aktivieren',
    },
    sessions: {
        activeSessionsDesc: 'Dies sind alle deine derzeit aktiven Browser-Sitzungen.',
        noActiveSessions: 'Keine aktiven Sitzungen gefunden.',
        thisDevice: 'Dieses Gerät',
    },
    danger: {
        deleteAccountDesc: 'Dein Konto und alle zugehörigen Daten werden dauerhaft gelöscht.',
    },
    deleteShop: {
        title: 'Salon löschen',
        desc: 'Das Löschen deines Salons archiviert ihn und deaktiviert alle Dienste. Alle Benutzer werden abgemeldet.',
        dialogTitle: 'Salon löschen',
        dialogDesc: 'Das Löschen deines Salons archiviert ihn und deaktiviert alle Dienste.',
        confirmButton: 'Salon löschen',
    },

    // Update Password Form
    password: {
        updateTitle: 'Passwort ändern',
        updateDesc: 'Verwende ein langes, zufälliges Passwort, um dein Konto sicher zu halten.',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen',
        updateButton: 'Passwort ändern',
        saved: 'Gespeichert.',
        verifyTitle: 'Prüfe deine E-Mails',
        verifyDesc: 'Wir haben dir einen 6-stelligen Code per E-Mail gesendet. Gib ihn unten ein, um die Passwortänderung zu bestätigen.',
        verificationCode: 'Bestätigungscode',
        confirmChange: 'Änderung bestätigen',
        didntReceive: 'Code nicht erhalten?',
        resend: 'Erneut senden',
        resendIn: 'Code erneut senden in',
    },

    // Delete Account Form
    deleteAccount: {
        title: 'Konto löschen',
        desc: 'Sobald dein Konto gelöscht ist, werden alle Daten dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
        dialogTitle: 'Konto löschen',
        dialogDesc: 'Dies wird dein Konto und alle zugehörigen Daten dauerhaft löschen. Gib dein Passwort ein, dann schicken wir dir einen Code per E-Mail zur Bestätigung.',
        shopWarning: 'Bist du der einzige Admin deines Shops, wird auch der Shop gelöscht — mit allen Buchungen, Kunden, Leistungen und Mitarbeiterkonten.',
        dialogDescEmail: 'Dies wird dein Konto und alle zugehörigen Daten dauerhaft löschen. Wir schicken einen Code an {{email}} zur Bestätigung.',
        passwordPlaceholder: 'Gib dein Passwort ein',
        cancelButton: 'Abbrechen',
        deleteButton: 'Permanent löschen',
        sendCodeButton: 'Code per E-Mail senden',
        codeSent: 'Wir haben einen 6-stelligen Code an {{email}} geschickt. Gib ihn ein, um dein Konto dauerhaft zu löschen.',
        codeLabel: 'Code aus der E-Mail',
        resendCode: 'Neuen Code senden',
    },

    setup: {
        title: 'Erste Schritte',
        done: 'erledigt',
        shopInfoLabel: 'Salon-Informationen ausfüllen',
        shopInfoSub: 'Telefonnummer und Adresse hinzufügen',
        shopInfoLink: 'Zu Einstellungen',
        barbersLabel: 'Friseure hinzufügen',
        barbersSub: 'Friseurprofile und Arbeitszeiten einrichten',
        barbersLink: 'Friseure hinzufügen',
        servicesLabel: 'Leistungen hinzufügen',
        servicesSub: 'Angebote mit Preisen und Zeiten definieren',
        servicesLink: 'Leistungen hinzufügen',
        shareLink: 'Buchungslink teilen',
        copy: 'Kopieren',
        copied: 'Kopiert!',
        ofComplete: '{{count}} von {{total}} abgeschlossen',
    },

    settingsPage: {
        bookingQrDesc: 'Zeig diesen QR-Code in deinem Shop. Kunden scannen ihn mit der GetFade-App oder ihrer Kamera, um zu buchen.',
        bookingQrDownload: 'QR-Code herunterladen',
        legalPrivacy: 'Datenschutzerklärung', legalTerms: 'AGB', legalCookies: 'Cookie-Richtlinie', legalSupport: 'Hilfe & Support',
        title: 'Einstellungen',
        bookingLink: 'Dein Buchungslink',
        bookingLinkDesc: 'Teile diesen Link, damit Kunden online buchen können',
        copyLink: 'Link kopieren',
        haircutPreview: 'Frisuren-Vorschau',
        haircutPreviewDesc: 'Kunden scannen dies, um Frisuren mit KI vor der Buchung anzuprobieren.',
        currencyUSD: 'USD — Dollar',
        currencyEUR: 'EUR — Euro',
        currencyALL: 'ALL — Lek',
        googleMapsUrl: 'Google Maps-Link',
        googleMapsUrlHint: 'Öffne Google Maps, suche deinen Salon, tippe auf Teilen → Link kopieren und füge ihn hier ein.',
        shopInfo: 'Salon-Informationen',
        shopInfoDesc: 'Grundlegende Details über Ihren Salon, die für Kunden sichtbar sind.',
        shopName: 'Salonname',
        shopLogo: 'Salon-Logo',
        shopLogoDesc: 'Wird Kunden auf der Buchungsseite angezeigt. JPG, PNG oder WebP, max. 2MB.',
        languageDesc: 'Sprache des Dashboards für Ihr Konto.',
        uploadLogo: 'Logo hochladen',
        changeLogo: 'Logo ändern',
        fileTooLarge: 'Datei ist zu groß. Maximale Größe ist {{max}}.',
        invalidFileType: 'Bitte wählen Sie eine Bilddatei (JPG, PNG, WebP).',
        uploadFailed: 'Upload fehlgeschlagen. Versuchen Sie eine kleinere Datei oder ein anderes Format.',
        timezone: 'Zeitzone',
        timezonePlaceholder: 'z.B. Europe/Berlin',
        streetAddress: 'Straße',
        city: 'Stadt',
        stateRegion: 'Bundesland / Region',
        zipPostal: 'PLZ',
        country: 'Land',
        currency: 'Standardwährung',
        notifications: 'Benachrichtigungen',
        notificationsDesc: 'Steuern Sie, wie Sie Terminbenachrichtigungen erhalten.',
        soundNotifications: 'Ton-Benachrichtigungen',
        soundNotificationsDesc: 'Sound abspielen, wenn Sie eine Benachrichtigung erhalten.',
        emailNotifications: 'E-Mail-Benachrichtigungen',
        emailNotificationsDesc: 'E-Mail-Benachrichtigungen erhalten, wenn Termine gebucht oder aktualisiert werden.',
        preferencesSaved: 'Benachrichtigungseinstellungen gespeichert',
        settingsSaved: 'Einstellungen gespeichert',
        virtualHaircut: 'Virtual Haircut Try-On',
        virtualHaircutDesc: 'Teilen Sie diesen Link mit Kunden, damit sie Frisuren mit KI anprobieren können.',
        qrCode: 'QR-Code',
        qrCodeDesc: 'Teilen Sie diesen Code mit Ihren Kunden für einfachen Buchungszugriff.',
        qrCodeInfo: 'Richten Sie Ihre Handykamera auf diesen QR-Code oder teilen Sie ihn in sozialen Medien, Ihrer Website oder überall dort, wo Ihre Kunden ihn finden könnten.',
        downloadQR: 'QR-Code herunterladen',
        hairstylePreview: 'Frisuren-Vorschau',
        hairstylePreviewDesc: 'Teilen Sie diesen Link, damit Kunden Frisuren mit KI ausprobieren können.',
        bookingLanguage: 'Sprache der Buchungsseite',
        bookingLanguageHint: 'Die Sprache, in der Ihr öffentlicher Buchungslink Kunden angezeigt wird.',
        autoConfirmTitle: 'Buchungen automatisch bestätigen',
        autoConfirmDesc: 'Wenn aktiviert, werden Buchungen auf freien Plätzen automatisch bestätigt — keine manuelle Genehmigung erforderlich. Wenn deaktiviert, wird jede Buchung als ausstehend eingegeben und Sie entscheiden über Bestätigung oder Ablehnung.',
        requireAccountsTitle: 'Kundenkonten erforderlich',
        requireAccountsDesc: 'Wenn aktiviert, müssen sich Kunden vor der Buchung registrieren oder anmelden. Wenn deaktiviert, führt Ihr Buchungslink direkt zum Formular und Kunden geben nur ihren Namen und ihre Telefonnummer ein.',
        slotIntervalTitle: 'Buchungs-Zeitfenster',
        slotIntervalDesc: 'Wie oft Buchungen starten können. 15 Min = 9:00, 9:15, 9:30… 30 Min = 9:00, 9:30, 10:00…',
        defaultLanguage: 'Standardsprache für Buchungen',
        defaultLanguageHint: 'Kunden sehen diese Sprache standardmäßig. Sie können sie in ihrem Profil ändern.',
    },

    notif: {
        title: 'Benachrichtigungen',
        markAllRead: 'Alle als gelesen markieren',
        noNotifications: 'Noch keine Benachrichtigungen',
        view: 'Anzeigen',
        markAsRead: 'Als gelesen markieren',
        showMore: 'Mehr anzeigen',
    },

    reports: {
        title: 'Berichte',
        revenue: 'Umsatz',
        appointments: 'Termine',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
        noShows: 'Nicht erschienen',
        tipsCollected: 'Trinkgelder gesamt',
        byBarber: 'Nach Friseur',
        byService: 'Nach Leistung',
        completionRate: 'Abschlussrate',
        avgTicket: 'Ø Betrag',
        topPerformer: 'Top',
        tipsLabel: 'Trinkgeld',
        apptsLabel: 'Termine',
        noData: 'Keine Daten für diesen Zeitraum.',
        export: 'Exportieren',
        exportPdf: 'PDF',
        exportXlsx: 'Excel',
        exportCsv: 'CSV',
        dateRange: 'Zeitraum',
        from: 'Von',
        to: 'Bis',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
    },

    admin: {
        title: 'Plattform-Admin',
        superAdmin: 'Super Admin',
        overview: 'Übersicht',
        shops: 'Salons',
        activity: 'Aktivität',
        platformOverview: 'Plattform-Übersicht',
        allShops: 'Alle Salons',
        recentActivity: 'Letzte Aktivitäten',
        totalRevenue: 'Gesamtumsatz',
        totalBookings: 'Buchungen gesamt',
        activeShops: 'Aktive Salons',
        customers: 'Kunden',
        bookings30d: 'Buchungen · letzte 30 Tage',
        revenue6m: 'Umsatz · letzte 6 Monate',
        topShops: 'Top-Salons · diesen Monat',
        statusBreakdown: 'Statusaufschlüsselung',
        newShops: 'Neue Salons · letzte 7 Tage',
        recentBookings: 'Letzte Buchungen',
        viewAll: 'Alle anzeigen →',
        activeShopsLabel: 'Aktive Salons',
        todayBookings: 'Heutige Buchungen',
        cancelRate: 'Stornierungsrate',
        live: 'Live',
        noData: 'Noch keine Daten.',
        noActivity: 'Noch keine Aktivität.',
        noNewShops: 'Keine neuen Salons diese Woche.',
        last30: 'Letzte 30',
        vsLastMonth: '% vs. letzten Monat',
        signOut: 'Abmelden',
        joined: 'Beigetreten',
        booked: 'gebucht',
        totalLabel: 'gesamt',
        inactiveLabel: 'inaktiv',
        total: 'gesamt',
        today: 'heute',
        archived: 'Archiviert',
        archivedShops: 'Archivierte Salons',
        archivedShopsCount: 'archivierte Salons',
        noArchivedShops: 'Keine archivierten Salons.',
        restore: 'Wiederherstellen',
        companies: 'Unternehmen',
        users: 'Benutzer',
        plans: 'Pläne',
        subscriptions: 'Abonnements',
        auditLogs: 'Audit-Protokolle',
        roles: 'Rollen & Berechtigungen',
        settings: 'Einstellungen',
        createCompany: 'Unternehmen erstellen',
        editCompany: 'Unternehmen bearbeiten',
        companyDetails: 'Unternehmensdetails',
        deleteCompany: 'Unternehmen löschen',
        deleteCompanyConfirm: 'Sind Sie sicher, dass Sie dieses Unternehmen löschen möchten? Das Unternehmen und alle zugehörigen Daten werden vorläufig gelöscht.',
        forceDeleteConfirm: 'Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Alle Unternehmensdaten gehen verloren.',
        suspendCompany: 'Unternehmen sperren',
        activateCompany: 'Unternehmen aktivieren',
        impersonate: 'Als Admin anmelden',
        stopImpersonation: 'Zurück zum Admin',
        impersonating: 'Angemeldet als',
        createUser: 'Benutzer erstellen',
        editUser: 'Benutzer bearbeiten',
        userDetails: 'Benutzerdetails',
        deleteUser: 'Benutzer löschen',
        deleteUserConfirm: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
        resetPassword: 'Passwort zurücksetzen',
        resetPasswordConfirm: 'Ein neues temporäres Passwort für diesen Benutzer generieren?',
        assignRole: 'Rolle zuweisen',
        createPlan: 'Plan erstellen',
        editPlan: 'Plan bearbeiten',
        deletePlan: 'Plan löschen',
        deletePlanConfirm: 'Sind Sie sicher, dass Sie diesen Plan löschen möchten?',
        assignPlan: 'Plan zuweisen',
        changePlan: 'Plan ändern',
        cancelSubscription: 'Abonnement kündigen',
        allCompanies: 'Alle Unternehmen',
        activeOnly: 'Nur aktive',
        inactiveOnly: 'Nur inaktive',
        allUsers: 'Alle Benutzer',
        allRoles: 'Alle Rollen',
        allStatuses: 'Alle Status',
        search: 'Suchen...',
        noResults: 'Keine Ergebnisse gefunden.',
        actions: 'Aktionen',
        status: 'Status',
        role: 'Rolle',
        company: 'Unternehmen',
        email: 'E-Mail',
        phone: 'Telefon',
        name: 'Name',
        createdAt: 'Erstellt',
        barbers: 'Friseure',
        services: 'Services',
        appointments: 'Termine',
        revenue: 'Umsatz',
        lastBooking: 'Letzte Buchung',
        unlimited: 'Unbegrenzt',
        perMonth: '/Mo',
        perYear: '/Jahr',
        free: 'Kostenlos',
        trial: 'Testphase',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        pastDue: 'Überfällig',
        cancelled: 'Storniert',
        expired: 'Abgelaufen',
        save: 'Speichern',
        saving: 'Wird gespeichert...',
        confirm: 'Bestätigen',
        permanentDelete: 'Dauerhaft löschen',
        editPermissions: 'Berechtigungen bearbeiten',
        permissionsCount: 'Berechtigungen',
        rolesCount: 'Rollen',
        all: 'Alle',
        allPermissionsLocked: 'Alle Berechtigungen (gesperrt)',
        permissionMatrix: 'Berechtigungsmatrix',
        permission: 'Berechtigung',
        cancel: 'Abbrechen',
        more: 'mehr',
        viewUsers: 'Benutzer anzeigen',
        general: 'Allgemein',
        security: 'Sicherheit',
        features: 'Funktionen',
        maintenance: 'Wartung',
        maintenanceMode: 'Wartungsmodus',
        maintenanceModeDesc: 'Wartungsmodus aktivieren, um die Plattform vorübergehend zu deaktivieren.',
        appName: 'Anwendungsname',
        defaultTimezone: 'Standard-Zeitzone',
        supportEmail: 'Support-E-Mail',
        registrationEnabled: 'Registrierung aktiviert',
        requireEmailVerification: 'E-Mail-Verifizierung erforderlich',
    },

    apptIndex: {
        appointments: 'Termine',
        fullyBooked: 'Ausgebucht',
        selected: '{{count}} ausgewählt',
        confirmAll: 'Alle bestätigen',
        cancelAll: 'Alle stornieren',
        clear: 'Auswahl aufheben',
        confirmApptTooltip: 'Termin bestätigen',
        namePlaceholder: 'Max Mustermann',
        phonePlaceholder: '+49 XXX XXXXXXXX',
        minLabel: 'Min.',
        nowLabel: 'Jetzt',
        searchPlaceholder: 'Nach Name, Friseur oder Leistung suchen…',
        filterStatusAll: 'Alle Status',
        filterDateAll: 'Alle Daten',
        filterDateLast7d: 'Letzte 7 Tage',
        filterDateLast30d: 'Letzte 30 Tage',
        filterDateLast90d: 'Letzte 90 Tage',
        calendar: 'Kalender',
        list: 'Liste',
        kanban: 'Kanban',
    },

    // Landing page
    land: {
        // Navbar
        navHowItWorks: 'So funktioniert es',
        navFeatures: 'Was du bekommst',
        navPricing: 'Preise',
        navSupport: 'Fragen?',
        navLogin: 'Anmelden',
        navBook: 'Termin buchen',
        // Hero
        heroHeading: 'Schluss mit Terminzetteln',
        heroSub: 'Alles an einem Ort. Termine buchen, deine Friseure managen, Geld verdienen - online.',
        heroBtn: 'Kostenlos starten',
        heroBtn2: 'Wie es funktioniert',
        // Problem & Solution
        problemLabel: 'Deine Probleme',
        problemHeading: 'Ein Salon zu führen ist anstrengend',
        problemSub: 'Doppelt gebuchte Termine, Kunden, die nicht kommen, keine Ahnung wie viel du verdienst. Kennst du das?',
        problem1: 'Doppelbuchungen und Chaos',
        problem2: 'Bestände sind ein Albtraum',
        problem3: 'Kunden sind weg',
        problem4: 'Dein Team ist nicht synchron',
        solutionLabel: 'Unsere Lösung',
        solutionHeading: 'GetFade macht alles einfach',
        solutionSub: 'Ein System für alles. Intelligente Buchung, automatische Erinnerungen, echte Zahlen.',
        solution1: 'Smart-Buchung',
        solution2: 'Keine Doppelbuchungen',
        solution3: 'Zufriedene Kunden',
        solution4: 'Das Team weiß immer Bescheid',
        // Features
        featuresLabel: 'Das bekommst du',
        featuresHeading: 'Tools für echte Salons',
        featuresSub: 'Einfach. Praktisch. Von Friseuren gemacht.',
        feature1Title: 'Online-Buchung, die funktioniert',
        feature1Desc: 'Kunden buchen online, dein Kalender aktualisiert sich automatisch. Keine Doppelbuchungen mehr.',
        feature2Title: 'Verwalte deine Friseure',
        feature2Desc: 'Wer arbeitet wann, wer hat frei, wer ist am besten in was.',
        feature3Title: 'Schau dir deine Zahlen an',
        feature3Desc: 'Wie viel verdienst du, welche Services sind beliebt, wo kommt das Geld her.',
        feature4Title: 'Deine Services, deine Preise',
        feature4Desc: 'Deine Schnitte, Färbungen und alles andere - mit deinen Preisen.',
        feature5Title: 'Kunden buchen rund um die Uhr',
        feature5Desc: 'Teile einen Link. Sie buchen wann sie wollen, auch nachts.',
        feature6Title: 'In English, Deutsch, Shqip',
        feature6Desc: 'Deine Kunden buchen in ihrer Sprache.',
        // Feature cards (grid section)
        featureCardMobileTitle: 'Mobile-First Buchung',
        featureCardMobileDesc: 'Schöne und schnelle Buchungserfahrung auf jedem Gerät. Kunden buchen in Sekunden.',
        featureCardRemindersTitle: 'Intelligente Erinnerungen',
        featureCardRemindersDesc: 'Automatische SMS- und E-Mail-Erinnerungen reduzieren Ausfallquoten und halten Kunden informiert.',
        featureCardAnalyticsTitle: 'Geschäftsanalytik',
        featureCardAnalyticsDesc: 'Verfolge Einnahmen, beliebte Services, Kundentrends und Wachstumsmetriken leicht.',
        featureCardCollabTitle: 'Teamzusammenarbeit',
        featureCardCollabDesc: 'Teile Zeitpläne, Notizen und Kundeninformationen mit deinem gesamten Team in Echtzeit.',
        featureCardSecureTitle: 'Sicher und zuverlässig',
        featureCardSecureDesc: 'Sicherheit auf Bankenniveau mit verschlüsselten Daten. 99,9% Verfügbarkeitsgarantie.',
        featureCardFastTitle: 'Blitzschnell',
        featureCardFastDesc: 'Optimiert für Geschwindigkeit. Seiten laden sofort, auch bei langsamen Verbindungen.',
        // Stats
        statsLabel: 'Friseure nutzen GetFade gerade jetzt',
        stat1Value: '1.200+',
        stat1Label: 'Friseure',
        stat2Value: '15.000+',
        stat2Label: 'Buchungen',
        stat3Value: '98%',
        stat3Label: 'Zufrieden',
        stat4Value: '+€5K',
        stat4Label: 'Monatliche Einnahmen',
        // Comparison
        comparisonHeading: 'Warum GetFade schlägt die Papier + Kaos Methode',
        comparisonSub: 'Vergleiche die alte Weise mit dem GetFade-Weg',
        comparisonLabel: 'Funktion',
        comparisonTraditional: 'Traditionell (Papier, Telefon usw.)',
        comparisonFade: 'GetFade',
        comparisonFeature1: 'Termin-Verwaltung',
        comparisonFeature1Traditional: 'Papier, Telefon, überall notiert - Verwirrung',
        comparisonFeature1Fade: 'Ein zentrales System, alle Buchungen sichtbar',
        comparisonFeature2: 'Einnahmen verfolgen',
        comparisonFeature2Traditional: 'Cash am Ende des Tages zählen — keine Einblicke',
        comparisonFeature2Fade: 'Umsatz nach Tag, Friseur und Service — mit Trends',
        comparisonFeature3: 'Team-Koordination',
        comparisonFeature3Traditional: 'Chaos — niemand weiß wer arbeitet oder frei hat',
        comparisonFeature3Fade: 'Arbeitszeiten, Urlaub und Termine jedes Friseurs an einem Ort',
        comparisonFeature4: 'Kunden-Geschichte',
        comparisonFeature4Traditional: 'Notizen überall verstreut — kein echter Überblick',
        comparisonFeature4Fade: 'Besuche, Ausfälle und Lieblingsfriseur für jeden Kunden',
        comparisonFeature5: 'Skalierbarkeit',
        comparisonFeature5Traditional: 'Wächst mit dir bis zu einem Punkt — dann bricht es',
        comparisonFeature5Fade: 'Wächst mit dir von 1 bis 50+ Friseure ohne Probleme',
        // Testimonials
        testimonialsTitle: 'Von Friseuren geliebt',
        testimonialsSub: 'Siehe, was echte Friseure über GetFade sagen',
        // Pricing
        pricingLabel: 'Preise',
        pricingHeading: 'Einfach. Keine Überraschungen.',
        pricingSub: '',
        pricingDesc: 'Ein einfacher Plan für jeden Shop: 3 Monate kostenlos, danach €10 pro Monat. Keine Kreditkarte zum Start nötig, jederzeit kündbar.',
        pricingTrialDesc: 'Starte deine 3-monatige kostenlose Testversion ohne Kreditkarte.',
        planStarterName: 'Solo',
        planStarterPrice: 'Kostenlos',
        planStarterPer: 'immer',
        planStarterDesc: 'Wenn du gerade anfängst.',
        planStarterFeature1: '1 Salon',
        planStarterFeature2: 'Bis zu 3 Friseure',
        planStarterFeature3: 'Online-Buchung',
        planStarterFeature4: 'Basis-Dashboard',
        planProName: 'Shop',
        planProPrice: '€29',
        planProPer: '/Monat',
        planProDesc: 'Für wachsende Salons.',
        planProBadge: 'Die meisten wählen das',
        planProFeature1: 'Unbegrenzt Friseure',
        planProFeature2: 'Deine Zahlen sehen',
        planProFeature3: 'Zufriedene Kunden',
        planProFeature4: 'Schnelle Hilfe',
        planEnterpriseName: 'Kette',
        planEnterprisePrice: 'Lass uns reden',
        planEnterpriseDesc: 'Für größere Betriebe.',
        planEnterpriseFeature1: 'Mehrere Salons',
        planEnterpriseFeature2: 'Alles Maßgeschneidert',
        planEnterpriseFeature3: 'Dein Team',
        planCTA: 'Jetzt probieren',
        planContactUs: 'Meldung',
        // Pricing Plans (new names)
        planName1: 'Anfänger',
        planPrice1: 'Kostenlos',
        planDesc1: 'Perfekt für Einzelfriseure',
        planFeature1_1: 'Online-Buchung',
        planFeature1_2: '1 Ort',
        planFeature1_3: 'Bis zu 3 Friseure',
        planFeature1_4: 'Basis-Dashboard',
        planName2: 'Pro',
        planPrice2: '€10/Monat',
        planDesc2: 'Für Friseure, die schneller wachsen und immer ausgebucht sein wollen',
        planBadge2: '3 Monate gratis',
        planSubtext2: 'Verdiene dein Abonnement mit nur 1 zusätzlichen Kunden zurück',
        pricingFact1: "in den ersten 3 Monaten",
        pricingFact2: "pro Monat danach",
        pricingFact3: "Provision auf Buchungen",
        planFeature2_1: 'Alles im Starter',
        planFeature2_2: 'Unbegrenzte Friseure & Team-Zugang',
        planFeature2_3: 'Automatische E-Mail-Erinnerungen (reduziere Ausfallquoten)',
        planFeature2_4: 'Verfolge Einnahmen & Leistung in Echtzeit',
        planFeature2_5: 'Verwalte dein gesamtes Team von einem Dashboard',
        planName3: 'Unternehmen',
        planPrice3: 'Benutzerdefiniert',
        planDesc3: 'Für Ketten und große Salons',
        planFeature3_1: 'Alles im Pro-Plan',
        planFeature3_2: 'Mehrere Standorte',
        planFeature3_3: 'Benutzerdefinierte Integrationen',
        planFeature3_4: 'Dedizierter Support',
        planFeature3_5: 'API-Zugriff',
        // Hero Benefits Text
        heroBenefits: 'Kostenlos für immer • Keine Kreditkarte • 5 min Setup',
        // How It Works Steps
        step1Title: '1. In 5 Minuten einrichten',
        step1Desc: 'Füge deine Friseursalon-Informationen, Services, Preise und deine Friseure hinzu. Kein kompliziertes Setup.',
        step2Title: '2. Teile deinen Buchungslink',
        step2Desc: 'Gib deinen Kunden einen einfachen Link, um Termine rund um die Uhr über Handy oder Computer zu buchen.',
        step3Title: '3. Verwalte alles an einem Ort',
        step3Desc: 'Sehe alle Termine, Kundeninformationen, Einnahmen und Team-Zeitpläne in einem Dashboard.',
        // Smart Scheduling Section
        smartSchedulingTitle: 'Intelligente Terminplanung',
        smartSchedulingDesc: 'Verwalte die Zeitpläne deiner Friseure mühelos. Sehe die Verfügbarkeit, verwalte Buchungen und halte alle in Echtzeit koordiniert.',
        smartSchedulingFeature1: 'Einfache Planung',
        smartSchedulingFeature1Desc: 'Zieh-und-Drop-Termine, sehe Verfügbarkeit in Echtzeit',
        smartSchedulingFeature2: 'Keine Doppelbuchungen',
        smartSchedulingFeature2Desc: 'Automatische Konflikterkennung in deinem Team',
        smartSchedulingFeature3: 'Team-Koordination',
        smartSchedulingFeature3Desc: 'Alle sehen den gleichen Kalender, bleibt synchronisiert',
        // Footer additions
        colSupport: 'Support',
        linkPricing: 'Preise',
        linkDemo: 'Demo',
        linkHelp: 'Hilfecenter',
        linkContact: 'Kontakt',
        // Hero Section (new for redesign)
        heroLabel: 'Die moderne Friseursalon-Management-Plattform',
        heroTitle: 'Verwalten Sie Ihren Friseursalon mühelos',
        heroTrust: 'Friseursalons nutzen GetFade',
        heroRating: 'von über 2.000 Bewertungen',
        // Features Section (new for redesign)
        featuresFeature1: 'Intelligente Planung',
        featuresDesc1: 'Automatisierte Terminbuchung mit Echtzeitverfügbarkeit und sofortigen Kundenbestätigungen.',
        featuresFeature2: 'Teamverwaltung',
        featuresDesc2: 'Verwalten Sie Friseure, weisen Sie Services zu, legen Sie Zeitpläne fest und verfolgen Sie die Leistung an einem Ort.',
        featuresFeature3: 'Umsatzverfolgung',
        featuresDesc3: 'Echtzeiteinblicke in Verdienste, beliebte Services und Geschäftswachstumskennzahlen.',
        featuresFeature4: 'Kundenprofile',
        featuresDesc4: 'Speichern Sie Vorlieben, Servicehistorie und Notizen für jeden Kunden.',
        // Stats Section (new for redesign)
        statsBarbershops: 'Friseursalons wachsen mit GetFade',
        statsAppointments: 'Termine werden monatlich gebucht',
        statsRevenue: 'verarbeitete Einnahmen',
        statsSupport: 'Support wenn Sie ihn brauchen',
        // CTA Section (new for redesign)
        ctaTitle: 'Bereit, Ihren Friseursalon zu transformieren?',
        ctaSub: 'Schließen Sie sich Tausenden von Friseursalons an, die bereits GetFade nutzen, um mehr Termine zu buchen und mehr Umsatz zu verdienen.',
        // Lock in Loyalty
        retentionLabel: 'Wachstum',
        loyaltyHeading: 'Erweitern Sie Ihre\nKundenbasis',
        loyaltySub: 'Bieten Sie Kunden ein einfaches Buchungserlebnis. Reduzieren Sie No-Shows und bauen Sie eine starke Kundenbasis auf.',
        loyaltyBtn: 'Buchung aktivieren',
        // Features Showcase (section 2)
        showcaseLabel: 'Leistungsstarke Funktionen',
        showcaseTitle: 'Alles, was Sie für Ihren Salon brauchen',
        showcaseSub: 'Verwalten Sie Ihren Salon effizient, damit Sie sich auf großartige Frisuren konzentrieren können.',
        showcaseFeature1Title: 'Intelligente Buchung',
        showcaseFeature1Desc: 'Automatische Terminvergabe mit sofortigen Bestätigungen, Erinnerungen und Reduzierung von Ausfällen',
        showcaseFeature2Title: 'Kundenprofil',
        showcaseFeature2Desc: 'Speichern Sie Vorlieben, Notizen und Servicehistorie für jeden Stammkunden',
        showcaseFeature3Title: 'Teamverwaltung',
        showcaseFeature3Desc: 'Weisen Sie Barbiere zu, verfolgen Sie individuelle Zeitpläne und verwalten Sie die Arbeitsbelastung',
        showcaseFeature4Title: 'Analytik & Berichte',
        showcaseFeature4Desc: 'Echtzeiteinblicke in Umsatz, Termine, Kundentrends und mehr',
        showcaseFeature5Title: 'Kundenportal',
        showcaseFeature5Desc: 'Teilbarer Buchungslink für einfache Kundenreservierungen überall, jederzeit',
        showcaseFeature6Title: 'Leistungsverfolgung',
        showcaseFeature6Desc: 'Überwachen Sie die Barbierspiel-Leistung, Bewertungen und Serviceabschlussmetriken',
        // Barbers & Clients
        forLabel: 'Für',
        barbersTitle: 'Friseursalons',
        businessTitle: 'Friseure',
        barbersSub: 'Kontrollieren Sie Ihre Zeitplanung, Kunden, Einnahmen und Marke.',
        findOutHow: 'Mehr erfahren',
        // Shop Stories
        testimonialsLabel: 'Erfolgserfolge',
        shopStoriesTitle: 'Friseur-Erfolgserfolge',
        shopStoriesSub: 'Echte Salons, echtes Wachstum.',
        // Get Free
        startTodayLabel: 'Loslegen',
        getFreeTitle: 'Verwalten Sie Ihren\nFriseursalon',
        getFreeSub: 'In Minuten eingerichtet. Keine Kreditkarte erforderlich. Starten Sie noch heute mit Online-Buchungen.',
        getFreeBtn: 'Kostenlos starten',
        // FAQ
        faqLabel: 'Fragen?',
        faqTitle: 'Häufig gestellte Fragen',
        faqSub: 'Alles, was Sie über GetFade wissen müssen.',
        faqQ1: 'Wie beginne ich mit GetFade?',
        faqA1: 'Der Einstieg ist einfach! Melden Sie sich für ein kostenloses Konto an, legen Sie Ihre Dienstleistungen und Preise fest, fügen Sie Ihre Friseure hinzu und akzeptieren Sie Online-Buchungen. Die meisten Friseursalons sind in weniger als 10 Minuten einsatzbereit.',
        faqQ2: 'Gibt es eine Einrichtungsgebühr oder ist eine Kreditkarte erforderlich?',
        faqA2: "Nein. Es gibt keine Einrichtungsgebühr und Sie brauchen keine Kreditkarte. Sie nutzen das komplette Produkt 3 Monate kostenlos, danach kostet es €10 im Monat.",
        faqQ3: 'Kann ich mehrere Standorte verwalten?',
        faqA3: 'Derzeit verwaltet jedes GetFade-Konto einen Friseursalon. Wenn Sie mehrere Standorte haben, können Sie separate Konten für jeden Salon erstellen und diese unabhängig verwalten.',
        faqQ4: 'Wie buchen meine Kunden Termine?',
        faqA4: 'Deine Kunden buchen über deinen personalisierten Link. Sie wählen die Dienstleistung, den Friseur und die Uhrzeit — und bestätigen sofort.',
        faqQ5: 'Können Kunden Termine absagen oder verschieben?',
        faqA5: 'Ja, Kunden können ihre Buchungen je nach deinen Einstellungen verwalten.',
        faqQ6: "Was passiert, wenn die 3 kostenlosen Monate enden?",
        faqA6: "Es wird nichts automatisch abgebucht, denn wir haben nie nach Ihrer Karte gefragt. Um GetFade weiter zu nutzen, wechseln Sie zum Plan für €10 im Monat. Andernfalls werden Dashboard, App und Buchungsseite ausgeschaltet, bis Sie fortfahren. Ihre Daten bleiben erhalten.",
        faqQ7: "Nehmen Sie eine Provision auf meine Buchungen?",
        faqA7: "Nein. Sie zahlen pauschal €10 im Monat, egal ob 20 oder 2.000 Buchungen. Was Sie Ihren Kunden berechnen, gehört Ihnen, ohne Provision und ohne Gebühren pro Buchung.",
        // Footer
        footerTagline: 'Das komplette Verwaltungssystem für Friseursalons. Einfach, leistungsstark und zuverlässig.',
        colProduct: 'Produkt',
        colCompany: 'Unternehmen',
        colResources: 'Ressourcen',
        colLegal: 'Rechtliches',
        linkHowItWorks: 'So funktioniert es',
        linkStories: 'Erfahrungen',
        linkGetStarted: 'Loslegen',
        linkAbout: 'Über uns',
        linkBlog: 'Blog',
        linkCareers: 'Karriere',
        linkPrivacy: 'Datenschutz',
        linkTerms: 'AGB',
        linkSecurity: 'Sicherheit',
        linkCookies: 'Cookies',
        supportLabel: 'Support',
        supportTitle: 'Brauchen Sie Hilfe?',
        supportSub: 'Hinterlassen Sie Ihre E-Mail und wir melden uns so schnell wie möglich.',
        supportPlaceholder: 'ihre@email.de',
        supportBtn: 'Senden',
        supportSent: 'Wir haben Ihre Nachricht erhalten — wir melden uns bald.',
        copyright: '© 2026 GetFade. Alle Rechte vorbehalten.',
        builtBy: 'Gebaut für Friseure, von Friseuren.',
        madeBy: 'Erstellt von',
        // an2tech section
        an2techLabel: 'Das Team dahinter',
        an2techHeading: 'Möchten Sie ein solches Produkt\nfür Ihr Unternehmen?',
        an2techSub: 'an2tech entwickelt moderne Web-Apps, SaaS-Plattformen und digitale Tools — schnell, sauber und produktionsbereit.',
        an2techBtn: 'Zusammenarbeiten',
        an2techTagline: 'Design · Entwicklung · Launch',
        // Cookie banner
        cookieText: 'Wir verwenden nur notwendige Cookies, damit du angemeldet bleibst. Optionale Cookies würden wir nur mit deiner Zustimmung nutzen.',
        cookieAccept: 'Akzeptieren',
        cookieDecline: 'Ablehnen',
        cookieLearnMore: 'Mehr erfahren',
    },

    // Toast notifications
    toast: {
        notificationsMarkedAsRead: 'Alle Benachrichtigungen als gelesen markiert',
        walkinBooked: 'Walk-in für {{name}} gebucht.',
        newBooking: 'Neue Buchung erhalten!',
        newBookingFrom: 'Neue Buchung von {{name}}',
        aCustomer: 'Ein Kunde',
        autoConfirmedFrom: 'Neue Buchung automatisch bestätigt: {{name}}',
        autoConfirmedEyebrow: 'Neuer Termin · Bestätigt',
        bookingConfirmed: 'Buchung bestätigt',
        bookingDeclined: 'Buchung abgelehnt',
        customerCreated: 'Kunde erfolgreich hinzugefügt.',
        goalsUpdated: 'Ziele aktualisiert.',
        sponsorAdded: 'Sponsor hinzugefügt.',
        sponsorUpdated: 'Sponsor aktualisiert.',
        sponsorRemoved: 'Sponsor entfernt.',
        serviceCreated: 'Service erstellt.',
        serviceUpdated: 'Service aktualisiert.',
        serviceDeleted: 'Service gelöscht.',
        customerDeleted: 'Kunde gelöscht.',
        appointmentCreated: 'Termin erstellt.',
        appointmentUpdated: 'Termin aktualisiert.',
        appointmentConfirmed: 'Termin bestätigt.',
        appointmentDeclined: 'Termin abgelehnt.',
        appointmentCancelledByStaff: 'Termin storniert.',
        appointmentStatusUpdated: 'Terminstatus aktualisiert.',
        appointmentDeleted: 'Termin gelöscht.',
        barberCreated: 'Friseur erstellt.',
        barberUpdated: 'Friseur aktualisiert.',
        barberDeleted: 'Friseur gelöscht.',
        barberAvailable: 'Friseur ist jetzt verfügbar.',
        barberUnavailable: 'Friseur heute als nicht verfügbar markiert.',
        scheduleUpdated: 'Zeitplan aktualisiert.',
        timeOffAdded: 'Freizeit hinzugefügt.',
        timeOffRemoved: 'Freizeit entfernt.',
        shopActivated: 'Shop aktiviert.',
        shopDeactivated: 'Shop deaktiviert.',
        shopRestored: 'Salon erfolgreich wiederhergestellt.',
        shopPermanentlyDeleted: 'Salon endgültig gelöscht.',
        productCreated: 'Produkt erstellt.',
        productUpdated: 'Produkt aktualisiert.',
        productDeleted: 'Produkt gelöscht.',
        haircutCreated: 'Haarschnitt erstellt.',
        haircutUpdated: 'Haarschnitt aktualisiert.',
        haircutDeleted: 'Haarschnitt gelöscht.',
        passwordReset: 'Passwort wurde erfolgreich zurückgesetzt.',
    },
    dialogs: {
        confirmDeleteTimeOff: 'Sind Sie sicher, dass Sie diese Freizeit entfernen möchten?',
        confirmDeleteAd: 'Diese Anzeige löschen?',
        confirmCancelAppointment: 'Diesen Termin absagen?',
    },

    // Virtual Haircut
    virtualHaircut: {
        pageTitle: 'Virtual Haircut Try-On',
        pageDescription: 'Wählen Sie links einen Stil und sehen Sie die Vorschau auf der rechten Seite',
        chooseYourStyle: 'Wählen Sie Ihren Stil',
        chooseYourStyleDesc: 'Wählen Sie einen Haarschnitt, um zu sehen, wie er mit Ihrem Foto aussieht',
        chooseStyleFirst: 'Wählen Sie zuerst einen stil',
        chooseStyleFirstDesc: 'Wählen Sie links einen haarschnitt aus und öffnen Sie dann Ihre kamera, um ihn auszuprobieren.',
        yourPhoto: 'Ihr Foto',
        yourPhotoDesc: 'Machen Sie ein Selfie, um zu beginnen',
        readyToTryOn: 'Bereit zum ausprobieren?',
        readyToTryOnDesc: 'Machen Sie ein Selfie, um zu sehen, wie verschiedene Haarschnitte auf Ihnen aussehen',
        openCamera: 'Kamera öffnen',
        cameraPermissionRequired: 'Kameraberechtigung erforderlich',
        allowCameraAccess: 'Ermöglichen Sie den Kamerazugriff in Ihren Browsereinstellungen',
        aiPreview: 'KI-Vorschau',
        generatingPreview: 'Vorschau wird generiert...',
        upTo30Seconds: 'Bis zu 30 Sekunden',
        retakePhoto: 'Foto erneut machen',
        bookThisHaircut: 'Diesen Haarschnitt buchen',
        proTips: 'Profitipps',
        goodLighting: 'Gute beleuchtung hilft bei der genauigkeit',
        faceCameraDirectly: 'Schauen sie direkt in die kamera',
        tryAllStyles: 'Probieren sie alle stile vor der buchung aus',
        howItWorks: 'So funktioniert es',
        helpStep1Title: 'Wählen Sie einen Haarschnitt',
        helpStep1Desc: 'Durchsuchen Sie die Stile auf der rechten Seite und tippen Sie auf den gewünschten.',
        helpStep2Title: 'Machen Sie ein Selfie',
        helpStep2Desc: 'Verwenden Sie die Kamera oder laden Sie ein Foto hoch. Schauen Sie direkt bei guter Beleuchtung.',
        helpStep3Title: 'Sehen Sie Ihre Vorschau',
        helpStep3Desc: 'KI generiert eine Vorschau von Ihnen mit dem ausgewählten Haarschnitt.',
        gotIt: 'Verstanden',
        uploadPhoto: 'Foto hochladen',
        generatePreview: 'Vorschau generieren',
        serviceUnavailable: 'Diese Funktion ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.',
        updatingTitle: 'Wir verbessern diese Funktion',
        updatingDesc: 'Bitte versuchen Sie es gleich noch einmal — wir machen alles besser für Sie.',
        openingCamera: 'Kamera wird geöffnet...',
        before: 'Vorher',
        after: 'Nachher',
        tryAnotherStyle: 'Anderen Stil probieren',
        hairColor: 'Haarfarbe',
        colors: {
            natural: 'Natürlich',
            black: 'Schwarz',
            darkBrown: 'Braun',
            blonde: 'Blond',
        },
    },

    notifications: {
        title: 'Benachrichtigungen',
        newBookings: 'Neue Buchungen',
        today: 'Heutige Termine',
        empty: 'Keine Termine heute',
        upcoming: 'Du hast {{count}} bevorstehende Termine',
        upcomingWithTime: 'Du hast {{count}} bevorstehende Termine — erster um {{time}}',
        tomorrow: 'Du hast morgen {{count}} Termine',
        tomorrowWithTime: 'Du hast morgen {{count}} Termine — erster um {{time}}',
        allClearTitle: 'Alles ruhig',
        allClearBody: 'Keine Termine heute oder morgen.',
        seeAll: 'Alle anzeigen',
        unread: 'ungelesen',
        summary: {
            total: 'Heute gesamt',
            inProgress: 'Laufend',
            completed: 'Abgeschlossen',
            next: 'Nächster',
            now: 'Jetzt',
            inMinutes: 'in {{m}} Min',
            inHours: 'in {{h}}Std {{m}}Min',
        },
    },

    bookingAuth: {
        keepSignedIn: "Angemeldet bleiben",
        verifyTitle: "Bestätige deine E-Mail",
        verifySub: "Wir haben einen 6-stelligen Code an {{email}} geschickt. Gib ihn unten ein.",
        verifyCodeLabel: "Bestätigungscode",
        verifyBtn: "E-Mail bestätigen",
        verifying: "Wird bestätigt…",
        verifyResend: "Nicht erhalten? Neuen Code senden",
        verifyResent: "Ein neuer Code ist unterwegs.",
        verifySending: "Wird gesendet…",
        forgotTitle: "Passwort vergessen?",
        forgotSub: "Gib deine E-Mail ein und wir senden dir einen Link für ein neues Passwort.",
        sendResetLink: "Link senden",
        sending: "Wird gesendet…",
        backToSignIn: "Zurück zur Anmeldung",
        resetTitle: "Neues Passwort festlegen",
        googleContinue: "Weiter mit Google",
        orDivider: "oder",
        forgotPassword: "Passwort vergessen?",
        signUp: 'Registrieren',
        signIn: 'Anmelden',
        eyebrow: 'Termin buchen',
        tagline: 'Premium-Grooming',
        firstName: 'Vorname',
        firstNamePlaceholder: 'Max',
        lastName: 'Nachname',
        lastNamePlaceholder: 'Müller',
        phone: 'Telefonnummer',
        password: 'Passwort',
        passwordPlaceholder: 'Mindestens 6 Zeichen',
        confirmPassword: 'Passwort bestätigen',
        confirmPlaceholder: 'Passwort wiederholen',
        passwordsNoMatch: 'Passwörter stimmen nicht überein',
        email: 'E-Mail',
        emailPlaceholder: 'du@beispiel.de',
        contactRequired: 'Mindestens Telefonnummer oder E-Mail erforderlich.',
        createAccount: 'Konto erstellen',
        creatingAccount: 'Konto wird erstellt…',
        terms: 'Mit dem Fortfahren akzeptierst du die Bedingungen von {{shop}}.',
        identifierLabel: 'Telefonnummer oder E-Mail',
        identifierPlaceholder: '+49 30 1234567 oder du@beispiel.de',
        identifierHint: 'Gib die Telefonnummer oder E-Mail ein, mit der du dich registriert hast.',
        continueBtn: 'Weiter',
        checking: 'Wird geprüft…',
        passwordYour: 'Dein Passwort',
        signInBtn: 'Anmelden',
        signingIn: 'Anmeldung läuft…',
        welcomeBack: 'Willkommen zurück, {{name}}',
        errNoAccount: 'Kein Konto gefunden. Bitte registriere dich.',
        errEmailMismatch: 'Die E-Mail stimmt nicht mit dem zu dieser Nummer registrierten Konto überein.',
        errSomethingWrong: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        forcePasswordTitle: 'Neues Passwort festlegen',
        forcePasswordIntro: 'Dein Konto wurde von deinem Barbier erstellt. Lege ein neues Passwort fest, das nur du kennst.',
        newPassword: 'Neues Passwort',
        savePassword: 'Passwort speichern',
        savingPassword: 'Speichern…',
    },

    welcome: {
        metaTitle: 'Buchungssoftware für Barbershops',
        navFeatures: 'Funktionen',
        navHow: 'So funktioniert\'s',
        navModules: 'Module',
        navPricing: 'Preise',
        navSignIn: 'Anmelden',
        navBook: 'Termin buchen',
        heroEyebrow: 'Für Barbiere und ihre treuen Kunden',
        heroTitle: 'Buche deinen Barbier.',
        heroTitleAccent: 'in drei Klicks.',
        heroBigLine1: 'Buchen,',
        heroBigLine2: 'tippen, reingehen',
        heroBigLine3: 'frisch.',
        heroPill: 'Buchung, neu gedacht für Barbershops',
        heroSub: 'GetFade übernimmt Buchungen, Kunden, Termine und deinen Barbershop — damit du dich auf den Schnitt konzentrierst.',
        heroSubMuted: 'Keine DMs. Keine Doppelbuchungen. Keine Preisüberraschungen.',
        heroBadgeBooked: 'Gebucht',
        heroBadgeRevenue: '+€280 heute',
        tickerLabel: 'Vertraut von unabhängigen Shops in ganz Europa',
        directoryBadge: 'Demnächst',
        directoryEyebrow: 'Finde Barbiere in deiner Nähe',
        directoryHeadline: 'Hier werden alle Barbiere aus verschiedenen Städten gelistet — jeder mit seinem eigenen Link.',
        directoryIntro: 'Stöbere nach Stadt. Filtere nach Stil, Preis und Verfügbarkeit. Buche den Schnitt, den du wirklich willst — wo immer du bist.',
        directoryCityLabel: 'Stadt {{num}}',
        directoryCityTabsLabel: 'Städte',
        directoryExplainTitle: 'Jeder Barbier, in jeder Stadt.',
        directoryExplainBody: 'Wähle eine Stadt und sieh jeden Barbier, der dort arbeitet — Stile, Preise und freie Termine. Buche mit einem Tipp.',
        howIntro: "Der ganze Ablauf, von Anfang bis Ende, in weniger Zeit als einen Kamm zu spülen.",
        howStepBigEnding: 'Barbier.',
        featuresIntro: "Kalender, Kunden, Anzahlungen, Erinnerungen, Berichte. Ein ruhiges System, Ende der Geschichte.",
        featuresEnding: 'Nichts, was er nicht braucht.',
        featLabelCalendar: 'Kalender',
        featLabelClients: 'Kunden',
        featLabelReminders: 'Erinnerungen',
        featLabelReports: 'Berichte',
        featCalMonth: 'April',
        featCalYear: '2026',
        featNotifyNew: 'Neue Buchung · 11:00',
        featNotifyNewSub: 'Marco · Skin fade',
        featNotifyReminder: 'Erinnerung gesendet · 14:30',
        featNotifyReminderSub: 'James · Schnitt + Bart',
        featRevenueLabel: 'Diesen Monat',
        featRevenueAmount: '€4.280',
        featRevenueDelta: '+24%',
        clientName1: 'Marco Rossi',
        clientVisits1: '12 Besuche',
        clientLast1: 'vor 3T',
        clientName2: 'James Chen',
        clientVisits2: '8 Besuche',
        clientLast2: 'vor 1W',
        clientName3: 'Aiden Park',
        clientVisits3: '24 Besuche',
        clientLast3: 'heute',
        previewWeekday: 'Mittwoch',
        previewDate: '29. April',
        previewBooked: '6 gebucht · 2 frei',
        previewSideToday: 'Heute',
        previewSideCalendar: 'Kalender',
        previewSideClients: 'Kunden',
        previewSideServices: 'Services',
        previewSideReports: 'Berichte',
        previewSvcSkinFade: 'Skin Fade',
        previewSvcCutBeard: 'Schnitt + Bart',
        previewSvcShave: 'Heiße Rasur',
        previewSvcOpen: 'Freier Slot',
        previewNow: 'Jetzt',
        previewAdd: '+ Hinzu',
        quoteText: 'Wir haben vier Tools durch Getfade ersetzt.',
        quoteHighlight: '30 Schnitte mehr',
        quoteAfter: 'pro Woche.',
        quoteAuthor: 'Marco Folsom',
        quoteAuthorMeta: 'Folsom & Sons · London',
        pricePopular: '★ Beliebt',
        finalLine1: 'Dein nächster Schnitt ist',
        finalTaps: 'zwei Tipps',
        finalLine2: 'entfernt.',
        pricingHeadline1: 'Ein Preis.',
        pricingHeadline2: 'Keine Provision.',
        pricingIntro: 'Was du verlangst, behältst du. Wir nehmen keinen Anteil vom Schnitt.',
        heroBook: 'Termin buchen',
        heroForShops: 'Für Barbershops',
        previewTabBook: 'Buchen',
        previewTabShops: 'Shops',
        previewTabMy: 'Meine Termine',
        previewLocation: 'Berlin',
        previewShopName: 'Folsom & Sons',
        previewShopMeta: '12 Min Fußweg · ★ 4,9 (412)',
        previewService: 'Service',
        previewWhen: 'Wann',
        previewAvailable: 'Freie Zeiten',
        previewConfirm: 'Bestätigen',
        previewSummary: 'Di 28 · 11:00 · 60 Min · €10',
        howEyebrow: 'So funktioniert\'s',
        howTitle: 'Drei Schritte,',
        howTitleAccent: 'finde deinen Barbier.',
        howTitleAccentLead: 'finde deinen',
        howStep1Title: 'Finde deinen Barbier',
        howStep1Body: 'Suche nach Stadtteil, Stil oder Barbier. Sieh echte Schnitte, echte Preise, echte Bewertungen — nichts Aufgeblasenes.',
        howStep2Title: 'Sichere dir den Slot',
        howStep2Body: 'Wähle den Service, wähle die Zeit, halte ihn mit einer kleinen Anzahlung. Bis zwei Stunden vorher umbuchbar.',
        howStep3Title: 'Geh frisch geschnitten raus',
        howStep3Body: 'Tippe für Trinkgeld, bewerte den Schnitt, bucher per Tipp neu. Dein Barbier bekommt seinen nächsten Stammkunden.',
        featuresEyebrow: 'Für Shops',
        featuresTitle: 'Alles, was ein Shop braucht.',
        featuresTitleAccent: 'Nichts, was er nicht braucht.',
        feat1Title: 'Echtzeit-Stuhlkalender',
        feat1Body: 'Jeder Stuhl, jeder Barbier, jeder Slot in einer ruhigen Ansicht. Ziehen zum Umbuchen, tippen für Walk-in, nie doppelt buchen.',
        feat2Title: 'Anzahlungen, die halten',
        feat2Body: 'Anzahlung bei Buchung, sofortige Rückerstattung bei Stornierung, einbehalten bei Nichterscheinen. Deine Regeln, dein Shop.',
        feat3Title: 'Kundengedächtnis',
        feat3Body: 'Notizen zum Schnitt, zum Kind, zur Hochzeit nächste Woche. Automatisch gespeichert. Nichts geht zwischen Besuchen verloren.',
        feat4Title: 'Inhaber-Dashboard',
        feat4Body: 'Tagesumsatz, Kundentreue, Trinkgeldverteilung, No-Show-Rate. Die Zahlen, die dein Steuerberater verlangt, sofort bereit.',
        pricingEyebrow: 'Preise',
        pricingTitle: 'Einfach.',
        pricingTitleAccent: 'Pro Shop.',
        priceFreeTag: 'Testphase',
        priceFreeTitle: '3 Monate kostenlos',
        priceFreeDesc: 'Teste alle Funktionen ohne Kreditkarte.',
        priceFreeAmount: '€0',
        priceFreePer: 'für 3 Monate',
        priceFreeFeat1: 'Voller Zugriff auf alle Funktionen',
        priceFreeFeat2: 'Unbegrenzte Buchungen',
        priceFreeFeat3: 'Keine Kreditkarte nötig',
        priceFreeFeat4: 'Jederzeit kündbar',
        priceFreeCta: 'Kostenlos testen',
        pricePaidTag: 'Pro',
        pricePaidTitle: 'Alles, ohne Limits',
        pricePaidDesc: 'Für Barbiere und Shops, die wachsen wollen.',
        pricePaidAmount: '€10',
        pricePaidPer: '/ Monat',
        pricePaidYearNote: 'oder €100 / Jahr — spare €20',
        pricePaidFeat1: 'Echtzeit-Stuhlkalender',
        pricePaidFeat2: 'Inhaber-Dashboard & Berichte',
        pricePaidFeat3: 'SMS-Erinnerungen',
        pricePaidFeat4: 'Kundengedächtnis & Notizen',
        pricePaidFeat5: 'Vorrangiger Support',
        pricePaidCta: 'Loslegen',
        finalTitle: 'Dein nächster Schnitt ist',
        finalTitleAccent: 'zwei Tipps entfernt.',
        finalSub: 'Hör auf, deinem Barbier zu schreiben. Fang an, ihn zu buchen.',
        finalCtaList: 'Shop eintragen',
        footerTerms: 'AGB',
        footerPrivacy: 'Datenschutz',
        footerContact: 'Kontakt',
        footerRights: 'Alle Rechte vorbehalten.',
        footerMadeBy: 'Erstellt von',
        footerTagline: 'Buchungssoftware für unabhängige Barbershops.',
        appsHeading: 'Mobile Apps',
        appsComingSoon: 'Demnächst',
        appsAppStore: 'App Store',
        appsGooglePlay: 'Google Play',
        appsDownloadOn: 'Laden im',
        appsGetItOn: 'Jetzt bei',
        footerProduct: 'Produkt',
        footerCompany: 'Unternehmen',
        footerLegal: 'Rechtliches',
        navForBarbers: 'Für Barber',
        navResources: 'Ressourcen',
        navStart: 'Gratis testen',
        heroLine1: 'Dein Stuhl.',
        heroLine2: 'Voll gebucht.',
        heroCta: 'Kostenlos starten',
        heroCtaAlt: 'So funktioniert es',
        heroNote1: 'Keine Kreditkarte nötig',
        heroNote2: '3 Monate kostenlos',
        heroNote3: 'In Minuten eingerichtet',
        devDate: 'Morgen',
        devToday: 'Heute',
        devNew: 'Neue Buchung',
        devCollected: 'diese Woche eingenommen',
        devBookingsWeek: 'Buchungen diese Woche',
        proofHead: 'Für Barber, die keine DMs verwalten wollen.',
        proofTrusted: 'Über 1.000 Barbershops weltweit vertrauen darauf',
        flowTitle1: 'Einfach für deine Kunden.',
        flowTitle2: 'Mehr Zeit für dich.',
        flowStep1: 'Barber wählen',
        flowStep2: 'Service wählen',
        flowStep3: 'Zeit wählen',
        flowStep4: 'Buchung bestätigt',
        flowStep1Body: 'Kunden öffnen deinen Buchungslink und wählen ihren Barber.',
        flowStep2Body: 'Services, Dauer und Preise – alles klar auf einen Blick.',
        flowStep3Body: 'Nur wirklich freie Zeiten werden angezeigt, keine Doppelbuchungen.',
        flowStep4Body: 'Die Buchung landet sofort in deinem Kalender.',
        flowNote: 'Dein eigener GetFade-Link. Auf jedem Handy, rund um die Uhr.',
        phChooseBarber: 'Barber wählen',
        phSelectService: 'Service wählen',
        phPickTime: 'Zeit wählen',
        phBookNow: 'Jetzt buchen',
        phBooked: 'Gebucht!',
        phWith: 'bei',
        phAddCalendar: 'Zum Kalender',
        phSeeDetails: 'Details ansehen',
        phDashboard: 'Übersicht',
        phBookings: 'Buchungen',
        phClients: 'Kunden',
        phNewBooking: 'Neue Buchung',
        barberKicker: 'Für Barber',
        barberTitle1: 'Dein ganzer Tag.',
        barberTitle2: 'Ein Bildschirm.',
        barberPoint1: 'Alle Buchungen sehen. Doppelbuchungen vermeiden.',
        barberPoint2: 'Laufkundschaft und Termine verwalten.',
        barberPoint3: 'Schneller Zugriff auf Kunden, Notizen und Historie.',
        barberPoint4: 'Halte den Tag organisiert und den Stuhl besetzt.',
        barberCta: 'Kalender ansehen',
        toolsTitle1: 'Alle Werkzeuge.',
        toolsTitle2: 'Alles an einem',
        toolsTitle3: 'Ort.',
        toolBookings: 'Buchungen',
        toolBookingsDesc: 'Online-Buchung, die deinen Kalender füllt.',
        toolCalendar: 'Kalender',
        toolCalendarDesc: 'Echtzeit-Plan. Keine Überschneidungen.',
        toolClients: 'Kunden',
        toolClientsDesc: 'Kundenprofile, Notizen und Historie.',
        toolPayments: 'Zahlungen',
        toolPaymentsDesc: 'Zahlungen annehmen. Einnahmen verfolgen.',
        toolAnalytics: 'Analysen',
        toolAnalyticsDesc: 'Verstehe deinen Shop. Wachse.',
        toolBook: 'Buchen',
        toolVisits: 'Buchungen',
        toolEarnings: 'Gesamteinnahmen',
        setupTitle1: 'In drei Schritten',
        setupTitle2: 'startklar.',
        setupLead: 'Keine Installation, kein Vertrag. Erstelle deinen Salon und nimm heute die erste Buchung an.',
        setupCta: 'Kostenlos starten',
        setupStep1Title: 'Profil erstellen',
        setupStep1Body: 'Registrieren, Salonname und Foto hinzufügen. Dauert etwa zwei Minuten.',
        setupStep2Title: 'Services und Zeiten',
        setupStep2Body: 'Lege Preise, Dauer und Arbeitszeiten für jeden Barber fest.',
        setupStep3Title: 'Buchungen rund um die Uhr',
        setupStep3Body: 'Teile deinen Link. Kunden buchen selbst, du wirst sofort benachrichtigt.',
        statsTitle1: 'Mehr Schnitte.',
        statsTitle2: 'Weniger Admin.',
        statsLead: 'GetFade hilft Barbershops, Zeit zu sparen, Buchungen und Umsatz zu steigern.',
        statsExample: 'Beispielhafte Darstellung des GetFade-Dashboards.',
        statRev: 'Umsatz diesen Monat',
        statReturning: 'Wiederkehrende Kunden',
        statBookings: 'Buchungen diesen Monat',
        statPeak: 'Deine Stoßzeiten',
        statPeakValue: "Fr – So",
        statVs: 'vs. Vormonat',
        appTitle1: 'Verwalte deinen Shop.',
        appTitle2: 'Überall.',
        appPoint1: 'Heutigen Plan sehen',
        appPoint2: 'Buchungen verwalten',
        appPoint3: 'Kunden und Notizen anlegen',
        appPoint4: 'Zahlungen verfolgen',
        appPoint5: 'Sofort benachrichtigt werden',
        appDownload: 'Laden im',
        appGetOn: 'Jetzt bei',
        closeTitle1: 'Bereit für deine',
        closeTitle2: 'nächste Buchung?',
        closeSub: 'Erstelle deine GetFade-Seite in Minuten.',
        closeCta: 'Loslegen',
        closeFine: 'Keine Kreditkarte nötig.',
        footerBlurb: 'Buchungssoftware für unabhängige Barbershops.',
        footerBuilt: 'Für Barbershops gebaut.',
        footerAbout: 'Über uns',
        footerSecurity: 'Sicherheit',
        proofStat1: 'Barbershops auf GetFade',
        proofFactTrial: 'Monate kostenlos zum Start',
        proofFactPrice: 'pro Monat danach',
        proofFactBooking: 'Online-Buchung für deine Kunden',
        proofStatBarbers: 'Barbiere auf GetFade',
        proofStat2: 'Durchschnittsbewertung',
        proofStat3: 'Buchungen',
    },

    company: {
        pageTitle: 'Unsere Geschichte',
        heroEyebrow: 'Unsere Geschichte',
        heroLine1: 'Für das Handwerk gebaut.',
        heroLine2: 'Für Barber gebaut.',
        heroSub: 'GetFade begann auf einem Barbershop-Stuhl. Wir sahen, wie Barber Kunden durch übersehene Nachrichten, doppelt belegte Termine und Nichterscheinen verloren. Also bauten wir das Werkzeug, das wir uns gewünscht hätten.',

        missionEyebrow: 'Mission',
        missionTitle: 'Jedem Barber eine faire Chance geben',
        missionBody: 'Große Salonketten haben Software-Teams. Unabhängige Barber nicht. GetFade schafft gleiche Bedingungen mit professionellen Werkzeugen, die in Minuten eingerichtet und in Sekunden bedient sind.',

        valuesEyebrow: 'Wofür wir stehen',
        valuesTitle: 'Unsere Werte',
        value1Title: 'Tempo zuerst',
        value1Desc: 'Jede Funktion ist darauf ausgelegt, Zeit zu sparen — deine und die deiner Kunden.',
        value2Title: 'Datenschutz von Haus aus',
        value2Desc: 'Kundendaten gehören dir. Wir verkaufen sie nie, teilen sie nie und nutzen sie nicht für Werbung.',
        value3Title: 'Für alle gebaut',
        value3Desc: 'Barbershop-Kultur ist global — und wir sind es auch.',
        value4Title: 'Von der Community geprägt',
        value4Desc: 'Echte Barber gestalten unsere Roadmap. Jede große Funktion kam aus einem Kundenwunsch.',
        value5Title: 'Uns liegt wirklich etwas daran',
        value5Desc: 'Wir beantworten den Support selbst. Kein Bot. Keine Ticket-Warteschlange. Ein Mensch, dem es wichtig ist.',
        value6Title: 'Voll fokussiert',
        value6Desc: 'Wir machen eine Sache — Barbershop-Verwaltung. Und die besser als alle anderen.',

        ctaTitle1: 'Bereit,',
        ctaTitle2: 'dabei zu sein?',
        ctaSub: 'Starte heute dein kostenloses Konto. Keine Kreditkarte, keine Verträge — einfach ein besserer Weg, deinen Shop zu führen.',
        ctaButton: 'Kostenlos starten',
    },

    modules: {
        pageTitle: 'Module & Einrichtung',
        heroBadge: '11 Module',
        heroBadgeText: 'Alles, was ein Shop braucht',
        heroLine1: 'Eine Plattform.',
        heroLine2: 'Jedes Modul.',
        heroSub: 'GetFade ist das vollständige Betriebssystem für deinen Barbershop — Buchung, Kalender, Kunden, Zahlungen und Wachstum — alles an einem ruhigen Ort.',

        booking: { title: 'Buchung', desc: 'Echtzeit-Stuhlkalender. Kunden wählen Service, Barbier und Termin — fertig in unter einer Minute.' },
        barbers: { title: 'Barbiere', desc: 'Verwalte dein Team — Schichtpläne, Services pro Barbier, Auszeiten und Provisionsregeln pro Stuhl.' },
        customers: { title: 'Kunden', desc: 'Kundengedächtnis: Notizen zum Schnitt, zum Kind, zur Hochzeit nächste Woche. Automatisch gespeichert.' },
        appointments: { title: 'Termine', desc: 'Tagesansicht, Drag-to-reschedule, Walk-ins und Statusänderung mit einem Tipp. Keine Doppelbuchungen.' },
        services: { title: 'Services', desc: 'Deine Karte — Schnitte, Bart, Hot-Towel, Kinder. Setze Dauer, Preis und welche Barbiere sie anbieten.' },
        products: { title: 'Produkte', desc: 'Verkaufe Pomade, Bartöl und andere Pflegeprodukte an der Kasse. Inventar und Bestandswarnungen inklusive.' },
        notifications: { title: 'Benachrichtigungen', desc: 'E-Mail-Erinnerungen für Kunden sowie sofortige Benachrichtigungen über Buchungen und Stornierungen für dein Team — vollautomatisch.' },
        reports: { title: 'Berichte', desc: 'Tagesumsatz, Kundenbindung, Trinkgeldverteilung, No-Show-Rate. Die Zahlen, die dein Steuerberater fordert.' },
        marketing: { title: 'Marketing', desc: 'Promo-Posts, Sponsor-Marquees und saisonale Kampagnen, um leise Stunden zu füllen.' },
        qr: { title: 'QR-Stilvorschau', desc: 'Ein QR-Code für deinen Salon. Kunden scannen ihn, testen Frisuren mit KI und buchen den Look, der ihnen gefällt.' },
        settings: { title: 'Einstellungen', desc: 'Öffnungszeiten, Feiertage, Stornierungsregeln, Sprachen und Team-Berechtigungen.' },
        onboarding: { title: 'Onboarding', desc: 'Ein geführter 4-Schritte-Assistent, um deinen Shop, Services und ersten Stuhl in unter 5 Minuten einzurichten.' },

        setupLabel: 'Einrichtung',
        setupTitlePart1: 'Live in',
        setupTitleAccent: 'unter 5 Minuten',
        setupTitlePart2: '.',
        setupSub: 'Vier Schritte. Keine Programmierung nötig. Einfach registrieren und loslegen.',
        step1Title: 'Konto erstellen',
        step1Desc: 'Registrierung in 30 Sekunden. Keine Kreditkarte nötig.',
        step2Title: 'Shop hinzufügen',
        step2Desc: 'Öffnungszeiten, Adresse und Sprachen.',
        step3Title: 'Barbiere & Services hinzufügen',
        step3Desc: 'Baue dein Team und deine Karte auf — Dauer und Preise.',
        step4Title: 'Buchungslink teilen',
        step4Desc: 'Auf Instagram, Google oder als gedruckter QR-Code.',

        ctaPrimary: 'Kostenlos starten',
        ctaBack: 'Zurück zur Startseite',
        footerCopy: '© 2026 GetFade',
        footerPrivacy: 'Datenschutz',
        footerTerms: 'AGB',
        footerSecurity: 'Sicherheit',
    },

    qrScan: {
        title: 'QR-Code scannen',
        subtitle: 'Richte deine Kamera auf den QR-Code eines Friseursalons, um einen Termin zu buchen',
        openCamera: 'Kamera öffnen',
        clickToStart: 'Klicke, um mit dem Scannen zu beginnen',
        notValid: 'Dieser QR-Code ist ungültig. Bitte versuche einen anderen.',
        valid: 'QR-Code gültig!',
        redirecting: 'Weiterleitung zur Buchungsseite...',
        invalid: 'Ungültiger QR-Code',
        invalidDesc: 'Dies scheint kein gültiger Buchungs-QR-Code eines Friseursalons zu sein.',
        tryAgain: 'Erneut versuchen',
        howItWorks: 'So funktioniert es',
        step1: 'Öffne die Kamera und richte sie auf einen QR-Code',
        step2: 'Der Code wird automatisch gescannt',
        step3: 'Du wirst weitergeleitet, um Frisuren mit KI auszuprobieren',
        pointCamera: 'Kamera auf QR-Code richten',
        cameraError: 'Kamera kann nicht zugegriffen werden. Bitte überprüfe die Berechtigungen.',
    },

    portal: {
        myAppointments: 'Meine Termine',
        enterPhoneHint: 'Gib deine Telefonnummer ein, um deinen Buchungsverlauf zu sehen.',
        phoneNumber: 'Telefonnummer',
        lookingUp: 'Wird gesucht…',
        viewMyAppointments: 'Meine Termine anzeigen',
        wantToBook: 'Möchtest du buchen?',
        bookAppointment: 'Termin buchen',
        upcoming: 'Bevorstehend',
        noUpcoming: 'Keine bevorstehenden Termine.',
    },
    appWelcome: {
        clientBook: 'Termin buchen? Finde deinen Barbershop',
        tag: 'Für Barbiere & Shop-Inhaber',
        title: 'Führe deinen Shop vom Handy aus',
        sub: 'Buchungen, Kunden und dein ganzer Tag an einem Ort, mit einer Nachricht, sobald jemand bucht.',
        pointAlerts: 'Sofortige Buchungsbenachrichtigungen',
        pointSchedule: 'Dein Tagesplan auf einen Blick',
        create: 'Konto erstellen',
        signIn: 'Anmelden',
    },
    shopLink: {
        title: '{{shop}} in GetFade buchen',
        sub: 'Hol dir die kostenlose GetFade-App. Sie öffnet {{shop}}, sobald du sie startest.',
        getApp: 'GetFade laden',
        website: 'Lieber auf der Website buchen',
    },
    appBook: {
        title: 'Termin buchen',
        sub: 'Scanne den QR-Code deines Barbershops oder füge seinen Buchungslink ein.',
        scan: 'QR-Code scannen',
        or: 'oder',
        linkLabel: 'Buchungslink',
        linkPlaceholder: 'getfade.io/book/dein-barbershop',
        continue: 'Weiter',
        invalid: 'Das sieht nicht nach einem GetFade-Buchungslink aus.',
        notFound: 'Wir konnten diesen Barbershop nicht finden. Prüfe den Link und versuche es erneut.',
        yourShops: 'Deine Barbershops',
        staffPrompt: 'Barbier oder Shop-Inhaber?',
        staffLink: 'Anmelden',
    },
} as const;
